import { log } from "three"

export default {
  getCmType() {
    const cmTypeList = [
      {
        title: '常用函数',
        functionlist: [
          {
            model: 'cmIF',
            label: 'IF',
            typelable: '根据判断条件，返回正确或错误的值',
            popovertitle: `IF("1=1","1"，"2")`,
            popovertxt: '说明：\n当条件1=1进行判断时，如果判断成立返回1，反则返回2。'
          },
          {
            model: 'cmParseFloat',
            label: 'PARSEFLOAT',
            typelable: '转换数字函数，将返回字符串中的数字',
            popovertitle: `PARSEFLOAT("原始字符串")`,
            popovertxt: '说明：\nPARSEFLOAT会将传入的字符串进行转换，提取出字符串中的数字。'
          }
        ]
      },
      {
        title: '逻辑判断',
        functionlist: [
          {
            model: 'cmAND',
            label: 'AND',
            typelable: '逻辑与函数，所有条件都为真时返回true',
            popovertitle: `AND(条件1, 条件2, ...)`,
            popovertxt: '说明：\nAND会判断所有条件是否都为真，全部为真时返回true，否则返回false。\n\n示例：\nAND(1=1, 2>1)\n返回结果：true'
          },
          {
            model: 'cmOR',
            label: 'OR',
            typelable: '逻辑或函数，任一条件为真时返回true',
            popovertitle: `OR(条件1, 条件2, ...)`,
            popovertxt: '说明：\nOR会判断是否有任一条件为真，至少一个为真时返回true，全部为假时返回false。\n\n示例：\nOR(1=2, 2>1)\n返回结果：true'
          },
          {
            model: 'cmNOT',
            label: 'NOT',
            typelable: '逻辑非函数，对条件取反',
            popovertitle: `NOT(条件)`,
            popovertxt: '说明：\nNOT会对条件进行取反，条件为真返回false，条件为假返回true。\n\n示例：\nNOT(1=1)\n返回结果：false'
          },
          {
            model: 'cmIsEmpty',
            label: 'ISEMPTY',
            typelable: '判断是否为空函数，检查值是否为空',
            popovertitle: `ISEMPTY(值)`,
            popovertxt: '说明：\nISEMPTY会判断值是否为空（null、undefined、空字符串、空数组都视为空），为空返回true，否则返回false。\n\n示例：\nISEMPTY("")\n返回结果：true'
          },
          {
            model: 'cmIsNotEmpty',
            label: 'ISNOTEMPTY',
            typelable: '判断是否不为空函数，检查值是否不为空',
            popovertitle: `ISNOTEMPTY(值)`,
            popovertxt: '说明：\nISNOTEMPTY会判断值是否不为空，不为空返回true，为空返回false。\n\n示例：\nISNOTEMPTY("Hello")\n返回结果：true'
          },
          {
            model: 'cmIsNull',
            label: 'ISNULL',
            typelable: '判断是否为null函数',
            popovertitle: `ISNULL(值)`,
            popovertxt: '说明：\nISNULL会判断值是否为null或undefined，是则返回true，否则返回false。\n\n示例：\nISNULL(null)\n返回结果：true'
          },
          {
            model: 'cmIsNumber',
            label: 'ISNUMBER',
            typelable: '判断是否为数字函数',
            popovertitle: `ISNUMBER(值)`,
            popovertxt: '说明：\nISNUMBER会判断值是否为有效数字，是数字返回true，否则返回false。\n\n示例：\nISNUMBER(123) → 返回true\nISNUMBER("abc") → 返回false'
          },
          {
            model: 'cmIsString',
            label: 'ISSTRING',
            typelable: '判断是否为字符串函数',
            popovertitle: `ISSTRING(值)`,
            popovertxt: '说明：\nISSTRING会判断值是否为字符串类型，是字符串返回true，否则返回false。\n\n示例：\nISSTRING("Hello") → 返回true\nISSTRING(123) → 返回false'
          },
          {
            model: 'cmEquals',
            label: 'EQUALS',
            typelable: '相等判断函数，判断两个值是否相等',
            popovertitle: `EQUALS(值1, 值2)`,
            popovertxt: '说明：\nEQUALS会判断两个值是否相等（转换为字符串后比较），相等返回true，否则返回false。\n\n示例：\nEQUALS("123", 123)\n返回结果：true'
          },
          {
            model: 'cmNotEquals',
            label: 'NOTEQUALS',
            typelable: '不等判断函数，判断两个值是否不相等',
            popovertitle: `NOTEQUALS(值1, 值2)`,
            popovertxt: '说明：\nNOTEQUALS会判断两个值是否不相等，不相等返回true，相等返回false。\n\n示例：\nNOTEQUALS("123", "456")\n返回结果：true'
          }
        ]
      },
      {
        title: '字符串处理',
        functionlist: [
          {
            model: 'cmCONCAT',
            label: 'CONCAT',
            typelable: '字符串连接函数，返回传入函数中所有字段的链接字符串',
            popovertitle: `CONCAT("字符1","字符2"，"字符3"...)`,
            popovertxt: '说明：\nCONCAT会根据传入的字符，将所传入所有字符进行拼接，返回拼接后的字符串。\n\n特殊字符支持：\n• 换行符：使用 "\\n" 或 "\\r\\n"\n• 制表符：使用 "\\t"\n• 引号：使用 "\\"" 表示双引号，使用 "\\\'" 表示单引号\n• 反斜杠：使用 "\\\\" 表示反斜杠\n\n示例：\nCONCAT("Hello", " ", "World")\n返回结果："Hello World"\n\nCONCAT("第一行", "\\n", "第二行")\n返回结果：\n第一行\n第二行\n\nCONCAT("姓名：", "张三", "\\n", "电话：", "13800138000")\n返回结果：\n姓名：张三\n电话：13800138000'
          },
          {
            model: 'cmSplit',
            label: 'SPLIT',
            typelable: '分隔字符函数，将返回特定字符分隔后的指定下标结果',
            popovertitle: `SPLIT("原始字符串","特定字符"，返回下标值)`,
            popovertxt: '说明：\nSPLIT会根据传入的字符串，通过特定字符来分隔成数组，根据传入的下标来返回对应内容。\n\n示例：\nSPLIT("a,b,c", ",", 1)\n返回结果："b"'
          },
          {
            model: 'cmSubstring',
            label: 'SUBSTRING',
            typelable: '字符串截取函数，安全截取字符串内容',
            popovertitle: `SUBSTRING(字符串, 开始位置, 长度)`,
            popovertxt: '说明：\nSUBSTRING会安全截取字符串。\n\n示例：\nSUBSTRING("Hello World", 0, 5)\n返回结果："Hello"'
          },
          {
            model: 'cmReplace',
            label: 'REPLACE',
            typelable: '字符串替换函数，替换字符串中的内容',
            popovertitle: `REPLACE(字符串, 查找内容, 替换内容)`,
            popovertxt: '说明：\nREPLACE会替换字符串中的指定内容。\n\n示例：\nREPLACE("Hello World", "World", "China")\n返回结果："Hello China"'
          },
          {
            model: 'cmMultiReplace',
            label: 'MULTIREPLACE',
            typelable: '多组字符串替换函数，一次完成多组查找替换',
            popovertitle: `MULTIREPLACE(字符串, 查找1, 替换1, 查找2, 替换2, ...)`,
            popovertxt: '说明：\nMULTIREPLACE会按参数两两一组，依次全局替换字符串中的内容。\n适合公式引入符号（如 C/K/G/S）一次替换成多个数值。\n\n示例：\nMULTIREPLACE("C+K", "C", "10", "K", "20")\n返回结果："10+20"\n\n外径公式示例：\nEVAL(MULTIREPLACE(外径长公式, "C", SPLIT(内径尺寸, "*", 0), "K", SPLIT(内径尺寸, "*", 1), "G", SPLIT(内径尺寸, "*", 2), "S", 舌头))'
          },
          {
            model: 'cmTrim',
            label: 'TRIM',
            typelable: '去除首尾空格函数',
            popovertitle: `TRIM(字符串)`,
            popovertxt: '说明：\nTRIM会去除字符串首尾的空格。\n\n示例：\nTRIM("  Hello World  ")\n返回结果："Hello World"'
          },
          {
            model: 'cmContains',
            label: 'CONTAINS',
            typelable: '字符串包含判断函数，判断字符串中是否包含指定的子字符串',
            popovertitle: `CONTAINS(字符串, 子字符串)`,
            popovertxt: '说明：\nCONTAINS会判断字符串中是否包含指定的子字符串，返回true或false。\n\n示例：\nCONTAINS("Hello World", "World")\n返回结果：true'
          },
          {
            model: 'cmStartsWith',
            label: 'STARTSWITH',
            typelable: '字符串开头判断函数，判断字符串是否以指定的子字符串开头',
            popovertitle: `STARTSWITH(字符串, 子字符串)`,
            popovertxt: '说明：\nSTARTSWITH会判断字符串是否以指定的子字符串开头，返回true或false。\n\n示例：\nSTARTSWITH("Hello World", "Hello")\n返回结果：true'
          },
          {
            model: 'cmEndsWith',
            label: 'ENDSWITH',
            typelable: '字符串结尾判断函数，判断字符串是否以指定的子字符串结尾',
            popovertitle: `ENDSWITH(字符串, 子字符串)`,
            popovertxt: '说明：\nENDSWITH会判断字符串是否以指定的子字符串结尾，返回true或false。\n\n示例：\nENDSWITH("Hello World", "World")\n返回结果：true'
          },
          {
            model: 'cmLength',
            label: 'LENGTH',
            typelable: '字符串长度函数，返回字符串的字符长度',
            popovertitle: `LENGTH(字符串)`,
            popovertxt: '说明：\nLENGTH会返回字符串的字符长度。\n\n示例：\nLENGTH("Hello")\n返回结果：5'
          },
          {
            model: 'cmToUpperCase',
            label: 'TOUPPERCASE',
            typelable: '字符串转大写函数，将字符串转换为大写',
            popovertitle: `TOUPPERCASE(字符串)`,
            popovertxt: '说明：\nTOUPPERCASE会将字符串转换为大写。\n\n示例：\nTOUPPERCASE("hello")\n返回结果："HELLO"'
          },
          {
            model: 'cmToLowerCase',
            label: 'TOLOWERCASE',
            typelable: '字符串转小写函数，将字符串转换为小写',
            popovertitle: `TOLOWERCASE(字符串)`,
            popovertxt: '说明：\nTOLOWERCASE会将字符串转换为小写。\n\n示例：\nTOLOWERCASE("HELLO")\n返回结果："hello"'
          },
          {
            model: 'cmIndexOf',
            label: 'INDEXOF',
            typelable: '字符串查找函数，返回子字符串在字符串中首次出现的位置',
            popovertitle: `INDEXOF(字符串, 子字符串)`,
            popovertxt: '说明：\nINDEXOF会返回子字符串在字符串中首次出现的位置（从0开始），如果未找到则返回-1。\n\n示例：\nINDEXOF("Hello World", "World")\n返回结果：6'
          },
          {
            model: 'cmGetPinyinFirstLetter',
            label: 'GETPINYINFIRSTLETTER',
            typelable: '获取中文拼音首字母函数，将中文字符串转换为拼音首字母',
            popovertitle: `GETPINYINFIRSTLETTER(中文字符串)`,
            popovertxt: '说明：\nGETPINYINFIRSTLETTER会将中文字符串转换为拼音首字母，非中文字符保持原样。\n\n示例：\nGETPINYINFIRSTLETTER("北京") → 返回"BJ"\nGETPINYINFIRSTLETTER("Hello北京") → 返回"HelloBJ"'
          },
          {
            model: 'cmRandomString',
            label: 'RANDOMSTRING',
            typelable: '生成随机字符串函数，生成指定长度的字母数字组合字符串',
            popovertitle: `RANDOMSTRING(长度)`,
            popovertxt: '说明：\nRANDOMSTRING会生成指定长度的随机字符串，包含数字0-9和字母a-z（小写）。\n\n参数说明：\n• 长度：要生成的字符串长度，默认为32\n\n示例：\nRANDOMSTRING(32)\n返回结果：32位随机字母数字组合，如"a3f9k2m8p1q5r7s4t6u9v2w8x1y5z3"\n\nRANDOMSTRING(16)\n返回结果：16位随机字母数字组合'
          }
        ]
      },
      {
        title: '数学计算',
        functionlist: [
          {
            model: 'cmSUM',
            label: 'SUM',
            typelable: '合计计算函数，返回传入函数中所有数值的合计结果，传入值必须为数字类型',
            popovertitle: `SUM(数值,数值，数值...)`,
            popovertxt: '说明：\nSUM会根据传入的字段或数值，将所传入所有数字合计，返回汇总合计后的得数。\n\n示例：\nSUM(10, 20, 30)\n返回结果：60'
          },
          {
            model: 'cmRound',
            label: 'ROUND',
            typelable: '四舍五入函数，支持指定小数位数',
            popovertitle: `ROUND(数值, 小数位数)`,
            popovertxt: '说明：\nROUND会对数值进行四舍五入。\n\n示例：\nROUND(3.14159, 2)\n返回结果：3.14'
          },
          {
            model: 'cmCeil',
            label: 'CEIL',
            typelable: '向上取整函数',
            popovertitle: `CEIL(数值)`,
            popovertxt: '说明：\nCEIL会对数值向上取整。\n\n示例：\nCEIL(3.14)\n返回结果：4'
          },
          {
            model: 'cmFloor',
            label: 'FLOOR',
            typelable: '向下取整函数',
            popovertitle: `FLOOR(数值)`,
            popovertxt: '说明：\nFLOOR会对数值向下取整。\n\n示例：\nFLOOR(3.14)\n返回结果：3'
          },
          {
            model: 'cmRandom',
            label: 'RANDOM',
            typelable: '随机数生成函数',
            popovertitle: `RANDOM(最小值, 最大值)`,
            popovertxt: '说明：\nRANDOM会生成指定范围内的随机整数。\n\n示例：\nRANDOM(1, 100)\n返回结果：1-100之间的随机数'
          },
          {
            model: 'cmPercent',
            label: 'PERCENT',
            typelable: '百分比计算函数',
            popovertitle: `PERCENT(数值, 总数, 小数位数)`,
            popovertxt: '说明：\nPERCENT会计算百分比。\n\n示例：\nPERCENT(25, 100, 2)\n返回结果："25.00%"'
          }
        ]
      },
      {
        title: '日期时间',
        functionlist: [
          {
            model: 'cmFormatDate',
            label: 'FORMATDATE',
            typelable: '日期格式化函数，将日期转换为指定格式',
            popovertitle: `FORMATDATE(日期, "YYYY-MM-DD")`,
            popovertxt: '说明：\nFORMATDATE会将传入的日期转换为指定格式。\n\n示例：\nFORMATDATE("2024-01-01", "YYYY年MM月DD日")\n返回结果："2024年01月01日"'
          },
          {
            model: 'cmDateDiff',
            label: 'DATEDIFF',
            typelable: '日期差值计算函数，计算两个日期之间的差值',
            popovertitle: `DATEDIFF(日期1, 日期2, "days")`,
            popovertxt: '说明：\nDATEDIFF会计算两个日期之间的差值，支持days/hours/minutes等单位。\n\n示例：\nDATEDIFF("2024-01-01", "2024-01-10", "days")\n返回结果：9'
          },
          {
            model: 'cmNow',
            label: 'NOW',
            typelable: '获取当前日期时间函数',
            popovertitle: `NOW("YYYY-MM-DD HH:mm:ss")`,
            popovertxt: '说明：\nNOW会返回当前日期时间，支持自定义格式。\n\n示例：\nNOW("YYYY年MM月DD日")\n返回结果：当前日期，如"2024年01月01日"'
          },
          {
            model: 'cmDateAdd',
            label: 'DATEADD',
            typelable: '日期加减运算函数，对日期进行加减运算',
            popovertitle: `DATEADD(日期, 数值, "单位", "格式")`,
            popovertxt: '说明：\nDATEADD会对日期进行加减运算，正数表示加，负数表示减。\n\n支持的单位：\nyears/months/days/hours/minutes/seconds/weeks\n\n格式参数可选，默认为"YYYY-MM-DD"。\n\n示例：\nDATEADD("2024-01-01", 10, "days") → 返回"2024-01-11"\nDATEADD("2024-01-01", -5, "days") → 返回"2023-12-27"\nDATEADD("2024-01-01", 3, "months") → 返回"2024-04-01"'
          }
        ]
      },
      {
        title: '高级函数',
        functionlist: [
          {
            model: 'cmEval',
            label: 'EVAL',
            typelable: '公式转换函数，将传入的值转换为公式进行计算',
            popovertitle: `EVAL("公式内容")`,
            popovertxt: '说明：\nEVAL会将传入的计算内容转换为公式，返回公式计算结果。\n\n示例：\nEVAL("123*1")\n返回结果：123'
          },
          {
            model: 'cmToChinese',
            label: 'TOCHINESE',
            typelable: '金额转换大写函数，将数字金额转换为中文大写金额',
            popovertitle: `TOCHINESE(金额数值)`,
            popovertxt: '说明：\nTOCHINESE会将传入的数字金额转换为中文大写金额。\n\n示例：\nTOCHINESE(123.45)\n返回结果："壹佰贰拾叁元肆角伍分"'
          },
          {
            model: 'cmTableFind',
            label: 'TABLEFIND',
            typelable: '表格查找函数，从表格中查找符合条件的行并返回指定字段的值',
            popovertitle: `TABLEFIND(表格数据, 条件字段名, 条件值, 返回字段名, 操作符)`,
            popovertxt: '说明：\nTABLEFIND会从表格数据中查找第一个符合条件的行，返回指定字段的值。\n\n参数说明：\n1) 表格数据：使用表格整体组件（如"产品信息"），会自动转换为JSON字符串，如需使用数组方法需先用EVAL函数解析\n2) 条件字段名：必须使用字段的model值（字符串形式），如"input1750597899709"，不能使用字段显示名称\n3) 条件值：要匹配的值\n4) 返回字段名：必须使用字段的model值（字符串形式），如"num1750597985458"\n5) 操作符：可选，默认为"=="。支持的操作符：\n   - "==" 等于（默认）\n   - "!=" 不等于\n   - ">" 大于\n   - ">=" 大于等于\n   - "<" 小于\n   - "<=" 小于等于\n   - "contains" 包含（用于字符串包含判断）\n   - "not_contains" 不包含\n   - "startsWith" 以...开头\n   - "endsWith" 以...结尾\n   - "is_empty" 为空\n   - "is_not_empty" 不为空\n\n示例：\nTABLEFIND(产品信息, "input1750597899709", 材料信息.产品名称, "num1750597985458")\n说明：根据材料信息中的产品名称，从产品信息表格中查找对应的订货数量（精确匹配）\n\nTABLEFIND(产品信息, "input1750597899709", "食品", "num1750597985458", "contains")\n说明：查找产品名称包含"食品"的第一行，返回其订货数量'
          },
          {
            model: 'cmTableFindRow',
            label: 'TABLEFINDROW',
            typelable: '表格查找行函数，从表格中查找符合条件的行并返回整行数据',
            popovertitle: `TABLEFINDROW(表格数据, 条件字段名, 条件值, 操作符)`,
            popovertxt: '说明：\nTABLEFINDROW会从表格数据中查找第一个符合条件的行，返回整行数据的JSON字符串。\n\n参数说明：\n1) 表格数据：使用表格整体组件（如"产品信息"），会自动转换为JSON字符串，如需使用数组方法需先用EVAL函数解析\n2) 条件字段名：必须使用字段的model值（字符串形式），如"input1750597899709"，不能使用字段显示名称\n3) 条件值：要匹配的值\n4) 操作符：可选，默认为"=="。支持的操作符：\n   - "==" 等于（默认）\n   - "!=" 不等于\n   - ">" 大于\n   - ">=" 大于等于\n   - "<" 小于\n   - "<=" 小于等于\n   - "contains" 包含（用于字符串包含判断）\n   - "not_contains" 不包含\n   - "startsWith" 以...开头\n   - "endsWith" 以...结尾\n   - "is_empty" 为空\n   - "is_not_empty" 不为空\n\n示例：\nTABLEFINDROW(产品信息, "input1750597899709", "cp0002")\n说明：返回产品编号等于cp0002的整行数据（精确匹配）\n\nTABLEFINDROW(产品信息, "input1750597899709", "cp", "startsWith")\n说明：返回产品编号以"cp"开头的第一行整行数据'
          },
          {
            model: 'cmTableCount',
            label: 'TABLECOUNT',
            typelable: '表格计数函数，统计表格中符合条件的行数',
            popovertitle: `TABLECOUNT(表格数据, 条件字段名, 条件值, 操作符)`,
            popovertxt: '说明：\nTABLECOUNT会统计表格中符合条件的行数。\n\n参数说明：\n1) 表格数据：使用表格整体组件（如"产品信息"），会自动转换为JSON字符串，如需使用数组方法需先用EVAL函数解析\n2) 条件字段名：必须使用字段的model值（字符串形式），如"input1750597899709"，不能使用字段显示名称\n3) 条件值：要匹配的值\n4) 操作符：可选，默认为"=="。支持的操作符：\n   - "==" 等于（默认）\n   - "!=" 不等于\n   - ">" 大于\n   - ">=" 大于等于\n   - "<" 小于\n   - "<=" 小于等于\n   - "contains" 包含（用于字符串包含判断）\n   - "not_contains" 不包含\n   - "startsWith" 以...开头\n   - "endsWith" 以...结尾\n   - "is_empty" 为空\n   - "is_not_empty" 不为空\n\n示例：\nTABLECOUNT(产品信息, "input1750597899709", "食品标签")\n说明：返回产品种类等于"食品标签"的行数（精确匹配）\n\nTABLECOUNT(产品信息, "input1750597899709", "食品", "contains")\n说明：返回产品种类包含"食品"的行数'
          },
          {
            model: 'cmTableSum',
            label: 'TABLESUM',
            typelable: '表格求和函数，对表格中符合条件的行的指定字段进行求和',
            popovertitle: `TABLESUM(表格数据, 条件字段名, 条件值, 求和字段名, 操作符)`,
            popovertxt: '说明：\nTABLESUM会对表格中符合条件的行的指定字段进行求和。\n\n参数说明：\n1) 表格数据：使用表格整体组件（如"产品信息"），会自动转换为JSON字符串，如需使用数组方法需先用EVAL函数解析\n2) 条件字段名：必须使用字段的model值（字符串形式），如"input1750597899709"，不能使用字段显示名称。如果不需要条件筛选，可以传入空字符串""\n3) 条件值：要匹配的值。如果不需要条件筛选，可以传入空字符串""\n4) 求和字段名：必须使用字段的model值（字符串形式），如"num1750597985458"，不能使用字段显示名称\n5) 操作符：可选，默认为"=="。支持的操作符：\n   - "==" 等于（默认）\n   - "!=" 不等于\n   - ">" 大于\n   - ">=" 大于等于\n   - "<" 小于\n   - "<=" 小于等于\n   - "contains" 包含（用于字符串包含判断）\n   - "not_contains" 不包含\n   - "startsWith" 以...开头\n   - "endsWith" 以...结尾\n   - "is_empty" 为空\n   - "is_not_empty" 不为空\n\n示例：\nTABLESUM(产品信息, "input1750597899709", "食品标签", "num1750597985458")\n说明：返回产品种类等于"食品标签"的所有行的金额合计\n\nTABLESUM(产品信息, "input1750597899709", "食品", "num1750597985458", "contains")\n说明：返回产品种类包含"食品"的所有行的金额合计\n\nTABLESUM(产品信息, "num1750597985458", 100, "num1750597985458", ">=")\n说明：返回金额大于等于100的所有行的金额合计\n\nTABLESUM(产品信息, "", "", "num1750597985458")\n说明：返回产品信息表格中所有行的金额合计（无条件筛选）'
          },
          {
            model: 'cmTableJoin',
            label: 'TABLEJOIN',
            typelable: '表格拼接函数：把表格每行指定字段拼成文字，再把各行拼在一起',
            popovertitle: `TABLEJOIN(表格数据, 行内分隔符, 字段列表, 行间分隔符, 主表字段列表, 主表数据, 显示序号, 序号格式)`,
            popovertxt: "一句话：把表格每一行的若干字段拼成一段文字，再把各行拼在一起。\n\n【最常用写法（前 4 个参数就够）】\nTABLEJOIN(表格整体组件, 行内分隔符, \"字段model列表\", 行间分隔符)\n\n【参数怎么填】\n1) 表格数据：左侧点选「表格整体」（如部件信息），不要手写表名\n2) 行内分隔符：同一行里，各「字段组」之间用什么隔开，如 \"-\"、\" / \"\n3) 字段列表：字符串。用英文逗号 , 分隔多个字段组（必填字段 model，不是中文标签）\n4) 行间分隔符：行与行之间用什么隔开，如 \"\\n\"（换行）、\"；\"、\" | \"\n5～8) 可选：主表字段、主表数据、是否显示序号、序号格式\n\n【字段列表语法（重点）】\n• 单个字段：productName\n• 两字段默认用 * 连接：width*height → 50*40\n• 自定义中间符（用 |）：width|X|height → 50X40\n• 加后缀（一个冒号 :）：width|X|height:MM → 50X40MM\n• 前后缀（双冒号 ::）：address:【::】 → 【上海路1号】\n• 有条件才拼（?）：remark?remark → 备注不为空才拼备注\n\n【示例假设表格有 2 行】\n行1：名称=纸箱A，宽=50，高=40，地址=上海，备注=加急\n行2：名称=纸箱B，宽=60，高=50，地址=杭州，备注=（空）\n\n例1 最简单：只拼名称，行间换行\nTABLEJOIN(产品信息, \"\", \"productName\", \"\\n\")\n结果：\n纸箱A\n纸箱B\n\n例2 名称 + 尺寸，行内用 -，行间换行\nTABLEJOIN(产品信息, \"-\", \"productName,width|X|height:MM\", \"\\n\")\n结果：\n纸箱A-50X40MM\n纸箱B-60X50MM\n\n例3 备注为空则不拼备注\nTABLEJOIN(产品信息, \"-\", \"productName,remark?remark\", \"\\n\")\n结果：\n纸箱A-加急\n纸箱B\n（第2行没有备注，不会多出一个空备注）\n\n例4 带序号 + 地址括号\nTABLEJOIN(产品信息, \"-\", \"productName,width|X|height:MM,address:【::】\", \"\\n\", \"\", \"\", true, \"{index}. \")\n结果：\n1. 纸箱A-50X40MM-【上海】\n2. 纸箱B-60X50MM-【杭州】\n\n【注意】\n• 字段列表里请使用左侧点选插入的字段 model；示例中的 productName/width 等只是示意\n• 行间要换行时，行间分隔符填写 \"\\n\""
          },
          {
            model: 'cmRowIndex',
            label: 'ROWINDEX',
            typelable: '获取当前行号函数，返回当前数据所在的行号（从1开始）',
            popovertitle: `ROWINDEX()`,
            popovertxt: '说明：\nROWINDEX会返回当前数据所在的行号，行号从1开始计数。\n\n使用场景：\n• 只能在表格字段的公式中使用\n• 用于生成带行号的编号、序号等\n• 可以配合其他函数使用，如生成"第1行"、"序号1"等格式\n\n示例：\nROWINDEX()\n返回结果：1（第一行）、2（第二行）、3（第三行）...\n\nCONCAT("第", ROWINDEX(), "行")\n返回结果："第1行"、"第2行"、"第3行"...\n\nCONCAT("序号", ROWINDEX())\n返回结果："序号1"、"序号2"、"序号3"...'
          }
        ]
      },
      {
        title: '身份证处理',
        functionlist: [
          {
            model: 'cmValidateIdCard',
            label: 'VALIDATEIDCARD',
            typelable: '身份证号码验证函数，验证身份证号码格式是否正确',
            popovertitle: `VALIDATEIDCARD(身份证号)`,
            popovertxt: '说明：\nVALIDATEIDCARD会验证身份证号码的格式和校验码是否正确。\n\n示例：\nVALIDATEIDCARD("110101199001011234")\n返回结果：true或false'
          },
          {
            model: 'cmGetAgeFromIdCard',
            label: 'GETAGEFROMIDCARD',
            typelable: '从身份证号获取年龄函数',
            popovertitle: `GETAGEFROMIDCARD(身份证号)`,
            popovertxt: '说明：\nGETAGEFROMIDCARD会从身份证号码中提取出生日期并计算当前年龄。\n\n示例：\nGETAGEFROMIDCARD("110101199001011234")\n返回结果：34'
          },
          {
            model: 'cmGetGenderFromIdCard',
            label: 'GETGENDERFROMIDCARD',
            typelable: '从身份证号获取性别函数',
            popovertitle: `GETGENDERFROMIDCARD(身份证号)`,
            popovertxt: '说明：\nGETGENDERFROMIDCARD会从身份证号码中提取性别信息。\n\n示例：\nGETGENDERFROMIDCARD("110101199001011234")\n返回结果：男或女'
          },
          {
            model: 'cmGetBirthDateFromIdCard',
            label: 'GETBIRTHDATEFROMIDCARD',
            typelable: '从身份证号获取出生日期函数',
            popovertitle: `GETBIRTHDATEFROMIDCARD(身份证号)`,
            popovertxt: '说明：\nGETBIRTHDATEFROMIDCARD会从身份证号码中提取出生日期。\n\n示例：\nGETBIRTHDATEFROMIDCARD("110101199001011234")\n返回结果："1990-01-01"'
          },
          {
            model: 'cmGetRegionFromIdCard',
            label: 'GETREGIONFROMIDCARD',
            typelable: '从身份证号获取地区信息函数',
            popovertitle: `GETREGIONFROMIDCARD(身份证号)`,
            popovertxt: '说明：\nGETREGIONFROMIDCARD会从身份证号码中提取地区信息。\n\n示例：\nGETREGIONFROMIDCARD("110101199001011234")\n返回结果："北京市"'
          },
          {
            model: 'cmGetIdCardInfo',
            label: 'GETIDCARDINFO',
            typelable: '从身份证号获取完整信息函数',
            popovertitle: `GETIDCARDINFO(身份证号)`,
            popovertxt: '说明：\nGETIDCARDINFO会从身份证号码中提取所有信息（年龄、性别、出生日期、地区），返回JSON格式的完整信息。\n\n示例：\nGETIDCARDINFO("110101199001011234")\n返回结果：包含年龄、性别、出生日期、地区的JSON对象'
          }
        ]
      }
    ]

    return cmTypeList
  },
  //IF判断函数，(ifst：判断语句,trueval：真值,falseval：假值)
  cmIF(ifst, trueval, falseval) {  
    // 处理字符串类型的判断
    if (typeof ifst === 'string') {
      // 先尝试作为判断表达式执行
      try {
        const result = eval(ifst) 
        if (result) {
          return trueval
        } else {
          return falseval
        }
      } catch (e) { 
        // eval失败，作为字符串判断：非空字符串为true，空字符串为false
        if (ifst.trim() !== '') {
          return trueval
        } else {
          return falseval
        }
      }
    } else {
      // 其他类型：直接判断真假值
      if (ifst) {
        return trueval
      } else {
        return falseval
      }
    }
  },

  // 逻辑与函数
  cmAND(...args) {
    if (args.length === 0) {
      return false
    }
    return args.every(arg => {
      // 处理字符串类型的判断
      if (typeof arg === 'string') {
        try {
          return eval(arg)
        } catch (e) {
          return arg.trim() !== ''
        }
      }
      return Boolean(arg)
    })
  },

  // 逻辑或函数
  cmOR(...args) {
    if (args.length === 0) {
      return false
    }
    return args.some(arg => {
      // 处理字符串类型的判断
      if (typeof arg === 'string') {
        try {
          return eval(arg)
        } catch (e) {
          return arg.trim() !== ''
        }
      }
      return Boolean(arg)
    })
  },

  // 逻辑非函数
  cmNOT(arg) {
    // 处理字符串类型的判断
    if (typeof arg === 'string') {
      try {
        return !eval(arg)
      } catch (e) {
        return arg.trim() === ''
      }
    }
    return !Boolean(arg)
  },

  // 判断是否为空函数
  cmIsEmpty(value) {
    if (value === null || value === undefined) {
      return true
    }
    if (typeof value === 'string') {
      return value.trim() === ''
    }
    if (Array.isArray(value)) {
      return value.length === 0
    }
    if (typeof value === 'object') {
      return Object.keys(value).length === 0
    }
    return false
  },

  // 判断是否不为空函数
  cmIsNotEmpty(value) {
    return !this.cmIsEmpty(value)
  },

  // 判断是否为null函数
  cmIsNull(value) {
    return value === null || value === undefined
  },

  // 判断是否为数字函数
  cmIsNumber(value) {
    if (value === null || value === undefined || value === '') {
      return false
    }
    return !isNaN(Number(value)) && isFinite(value)
  },

  // 判断是否为字符串函数
  cmIsString(value) {
    return typeof value === 'string'
  },

  // 相等判断函数
  cmEquals(value1, value2) {
    return String(value1) === String(value2)
  },

  // 不等判断函数
  cmNotEquals(value1, value2) {
    return String(value1) !== String(value2)
  },
  //CONCA函数，返回多个字符串拼接值，(字段1，字段2，....)不定多个参数
  cmCONCAT(...args) {
    let retconcatst = ""
    args.forEach(item => {
      retconcatst += item.toString()
    })

    return retconcatst
  },
  //Split函数(labelst:要分隔的文字,sign:分隔标志字符，stnum:要返回的下标)
  cmSplit(labelst,sign,stnum){
    return  labelst.toString().split(sign)[stnum]
  },
  //ParseFloat函数：将字符串或数字转换为浮点数
  //支持多种输入类型：
  //1. 数字类型：直接返回
  //2. 字符串类型：使用parseFloat解析
  //3. 对象类型（兼容旧代码）：从id属性中提取数字
  cmParseFloat(labelst){
    // 如果传入的是数字，直接返回
    if (typeof labelst === 'number') {
      return labelst;
    }
    // 如果传入的是字符串，直接使用parseFloat解析
    if (typeof labelst === 'string') {
      return parseFloat(labelst) || 0;
    }
    // 如果传入的是对象且有id属性（兼容旧代码）
    if (labelst && typeof labelst === 'object' && labelst.id) {
      return parseFloat(labelst.id.replace(/[^0-9]/ig, "")) || 0;
    }
    // 其他情况，尝试转换为字符串后解析
    return parseFloat(String(labelst)) || 0;
  },
  //SUM函数，返回多个多个数值类型的汇总得数，必须为数字类型，(数值1，数值2，....)不定多个参数
  cmSUM(...args) {
    let retconcatst = 0
    args.forEach(item => {
      // 处理 undefined、null、空字符串等值，将它们视为 0
      if (item === undefined || item === null || item === '') {
        return // 跳过，相当于加 0
      }
      // 尝试转换为数字
      const numValue = Number(item)
      // 如果是有效数字，则累加；否则跳过（相当于加 0）
      if (!isNaN(numValue) && isFinite(numValue)) {
        retconcatst += numValue
      }
    })
    return retconcatst
  },
  //Eval函数，将传入的内容转换为公式(evalst:'公式内容')
  cmEval(evalst) {
    return eval(evalst)
  },
  //金额转换大写函数，将数字金额转换为中文大写金额(amount: 金额数值)
  cmToChinese(amount) {
    if (!amount || isNaN(amount)) {
      return '零元整'
    }
    
    // 处理负数
    const isNegative = amount < 0
    amount = Math.abs(amount)
    
    // 分离整数和小数部分
    const [integerPart, decimalPart = ''] = amount.toString().split('.')
    
    // 中文数字映射
    const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
    const units = ['', '拾', '佰', '仟']
    const bigUnits = ['', '万', '亿']
    
    // 转换整数部分
    let result = ''
    let integerStr = integerPart
    
    // 处理整数部分
    if (integerStr === '0') {
      result = '零'
    } else {
      // 按4位分组处理
      const groups = []
      while (integerStr.length > 0) {
        groups.unshift(integerStr.slice(-4))
        integerStr = integerStr.slice(0, -4)
      }
      
      groups.forEach((group, groupIndex) => {
        if (group === '0000') return
        
        let groupResult = ''
        let hasZero = false
        
        for (let i = 0; i < group.length; i++) {
          const digit = parseInt(group[i])
          const unit = units[group.length - 1 - i]
          
          if (digit === 0) {
            if (!hasZero && groupResult !== '') {
              groupResult += '零'
              hasZero = true
            }
          } else {
            groupResult += digits[digit] + unit
            hasZero = false
          }
        }
        
        // 去除末尾的零
        groupResult = groupResult.replace(/零+$/, '')
        
        if (groupResult) {
          result += groupResult + bigUnits[groups.length - 1 - groupIndex]
        }
      })
    }
    
    // 添加"元"
    if (result !== '零') {
      result += '元'
    } else {
      result = ''
    }
    
    // 处理小数部分
    if (decimalPart) {
      const jiao = parseInt(decimalPart[0] || '0')
      const fen = parseInt(decimalPart[1] || '0')
      
      if (jiao > 0) {
        result += digits[jiao] + '角'
      }
      
      if (fen > 0) {
        result += digits[fen] + '分'
      }
      
      // 如果没有角分，添加"整"
      if (jiao === 0 && fen === 0) {
        result += '整'
      }
    } else {
      // 没有小数部分，添加"整"
      result += '整'
    }
    
    // 处理特殊情况
    if (result === '') {
      result = '零元整'
    }
    
    // 添加负号
    if (isNegative) {
      result = '负' + result
    }
    
    return result
  },

  // 获取当前日期时间函数
  cmNow(format = "YYYY-MM-DD") {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    const seconds = String(now.getSeconds()).padStart(2, '0')
    
    return format
      .replace('YYYY', year)
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds)
  },

  // 日期差值计算函数
  cmDateDiff(date1, date2, unit = "days") {
    const d1 = new Date(date1)
    const d2 = new Date(date2)
    
    if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
      return 0
    }
    
    const diffTime = Math.abs(d2.getTime() - d1.getTime())
    
    switch (unit.toLowerCase()) {
      case 'days':
        return Math.floor(diffTime / (1000 * 60 * 60 * 24))
      case 'hours':
        return Math.floor(diffTime / (1000 * 60 * 60))
      case 'minutes':
        return Math.floor(diffTime / (1000 * 60))
      case 'seconds':
        return Math.floor(diffTime / 1000)
      case 'years':
        return Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365))
      default:
        return Math.floor(diffTime / (1000 * 60 * 60 * 24))
    }
  },

  // 日期格式化函数
  cmFormatDate(date, format = "YYYY-MM-DD") {
    const d = new Date(date)
    if (isNaN(d.getTime())) {
      return date
    }
    
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    const hours = String(d.getHours()).padStart(2, '0')
    const minutes = String(d.getMinutes()).padStart(2, '0')
    const seconds = String(d.getSeconds()).padStart(2, '0')
    
    return format
      .replace('YYYY', year)
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds)
  },

  // 日期加减运算函数
  cmDateAdd(date, value, unit = "days", format = "YYYY-MM-DD") {
    const d = new Date(date)
    if (isNaN(d.getTime())) {
      return date
    }
    
    const numValue = Number(value)
    if (isNaN(numValue)) {
      return date
    }
    
    const resultDate = new Date(d)
    const unitLower = unit.toLowerCase()
    
    switch (unitLower) {
      case 'years':
      case 'year':
        resultDate.setFullYear(resultDate.getFullYear() + numValue)
        break
      case 'months':
      case 'month':
        resultDate.setMonth(resultDate.getMonth() + numValue)
        break
      case 'days':
      case 'day':
        resultDate.setDate(resultDate.getDate() + numValue)
        break
      case 'hours':
      case 'hour':
        resultDate.setHours(resultDate.getHours() + numValue)
        break
      case 'minutes':
      case 'minute':
        resultDate.setMinutes(resultDate.getMinutes() + numValue)
        break
      case 'seconds':
      case 'second':
        resultDate.setSeconds(resultDate.getSeconds() + numValue)
        break
      case 'weeks':
      case 'week':
        resultDate.setDate(resultDate.getDate() + (numValue * 7))
        break
      default:
        // 默认按天处理
        resultDate.setDate(resultDate.getDate() + numValue)
    }
    
    // 格式化返回
    return this.cmFormatDate(resultDate, format)
  },

  // 字符串截取函数
  cmSubstring(str, start, length) {
    if (!str || typeof str !== 'string') {
      return ''
    }
    return str.substring(start, start + length)
  },

  // 字符串替换函数
  cmReplace(str, searchValue, replaceValue) {
    if (!str || typeof str !== 'string') {
      return str
    }
    return str.replace(new RegExp(searchValue, 'g'), replaceValue)
  },

  // 多组字符串替换：MULTIREPLACE(字符串, 查找1, 替换1, 查找2, 替换2, ...)
  cmMultiReplace(str, ...pairs) {
    if (str === undefined || str === null) {
      return str
    }
    let result = typeof str === 'string' ? str : String(str)
    for (let i = 0; i + 1 < pairs.length; i += 2) {
      const searchValue = pairs[i]
      if (searchValue === undefined || searchValue === null || searchValue === '') {
        continue
      }
      const replaceValue = pairs[i + 1]
      const safeReplace = replaceValue === undefined || replaceValue === null ? '' : String(replaceValue)
      result = result.replace(new RegExp(String(searchValue), 'g'), safeReplace)
    }
    return result
  },

  // 去除首尾空格函数
  cmTrim(str) {
    if (!str || typeof str !== 'string') {
      return str
    }
    return str.trim()
  },

  // 字符串包含判断函数
  cmContains(str, searchString) {
    if (!str || typeof str !== 'string') {
      return false
    }
    if (!searchString || typeof searchString !== 'string') {
      return false
    }
    return str.includes(searchString)
  },

  // 字符串开头判断函数
  cmStartsWith(str, searchString) {
    if (!str || typeof str !== 'string') {
      return false
    }
    if (!searchString || typeof searchString !== 'string') {
      return false
    }
    return str.startsWith(searchString)
  },

  // 字符串结尾判断函数
  cmEndsWith(str, searchString) {
    if (!str || typeof str !== 'string') {
      return false
    }
    if (!searchString || typeof searchString !== 'string') {
      return false
    }
    return str.endsWith(searchString)
  },

  // 字符串长度函数
  cmLength(str) {
    if (!str) {
      return 0
    }
    return String(str).length
  },

  // 字符串转大写函数
  cmToUpperCase(str) {
    if (!str || typeof str !== 'string') {
      return str
    }
    return str.toUpperCase()
  },

  // 字符串转小写函数
  cmToLowerCase(str) {
    if (!str || typeof str !== 'string') {
      return str
    }
    return str.toLowerCase()
  },

  // 字符串查找函数
  cmIndexOf(str, searchString) {
    if (!str || typeof str !== 'string') {
      return -1
    }
    if (!searchString || typeof searchString !== 'string') {
      return -1
    }
    return str.indexOf(searchString)
  },


  // 获取中文拼音首字母函数（完整映射表版本）
  cmGetPinyinFirstLetter(str) {
    if (!str || typeof str !== 'string') {
      return ''
    }

    // 完整的拼音首字母映射表（包含所有常用汉字）
    // 中文字符Unicode范围：\u4e00-\u9fa5
    const pinyinMap = {
      'A': ['啊', '阿', '埃', '挨', '哎', '唉', '哀', '皑', '癌', '蔼', '矮', '艾', '碍', '爱', '隘', '鞍', '氨', '安', '俺', '按', '暗', '岸', '胺', '案', '肮', '昂', '盎', '凹', '敖', '熬', '翱', '袄', '傲', '奥', '懊', '澳'],
      'B': ['芭', '捌', '扒', '叭', '吧', '笆', '八', '疤', '巴', '拔', '跋', '靶', '把', '耙', '坝', '霸', '罢', '爸', '白', '柏', '百', '摆', '佰', '败', '拜', '稗', '斑', '班', '搬', '扳', '般', '颁', '板', '版', '扮', '拌', '伴', '瓣', '半', '办', '绊', '邦', '帮', '梆', '榜', '膀', '绑', '棒', '磅', '蚌', '镑', '傍', '谤', '苞', '胞', '包', '褒', '剥', '薄', '雹', '保', '堡', '饱', '宝', '抱', '报', '暴', '豹', '鲍', '爆', '杯', '碑', '悲', '卑', '北', '辈', '背', '贝', '钡', '倍', '狈', '备', '惫', '焙', '被', '奔', '苯', '本', '笨', '崩', '绷', '甭', '泵', '蹦', '迸', '逼', '鼻', '比', '鄙', '笔', '彼', '碧', '蓖', '蔽', '毕', '毙', '毖', '币', '庇', '痹', '闭', '敝', '弊', '必', '辟', '壁', '臂', '避', '陛', '鞭', '边', '编', '贬', '扁', '便', '变', '卞', '辨', '辩', '辫', '遍', '标', '彪', '膘', '表', '鳖', '憋', '别', '瘪', '彬', '斌', '濒', '滨', '宾', '摈', '兵', '冰', '柄', '丙', '秉', '饼', '炳', '病', '并', '玻', '菠', '播', '拨', '钵', '波', '博', '勃', '搏', '铂', '箔', '伯', '帛', '舶', '脖', '膊', '渤', '泊', '驳', '捕', '卜', '哺', '补', '埠', '不', '布', '步', '簿', '部', '怖'],
      'C': ['擦', '猜', '裁', '材', '才', '财', '睬', '踩', '采', '彩', '菜', '蔡', '餐', '参', '蚕', '残', '惭', '惨', '灿', '苍', '舱', '仓', '沧', '藏', '操', '糙', '槽', '曹', '草', '厕', '策', '侧', '册', '测', '层', '蹭', '插', '叉', '茬', '茶', '查', '碴', '搽', '察', '岔', '差', '诧', '拆', '柴', '豺', '搀', '掺', '蝉', '馋', '谗', '缠', '铲', '产', '阐', '颤', '昌', '猖', '场', '尝', '常', '长', '偿', '肠', '厂', '敞', '畅', '唱', '倡', '超', '抄', '钞', '朝', '嘲', '潮', '巢', '吵', '炒', '车', '扯', '撤', '掣', '彻', '澈', '郴', '臣', '辰', '尘', '晨', '忱', '沉', '陈', '趁', '衬', '撑', '称', '城', '橙', '成', '呈', '乘', '程', '惩', '澄', '诚', '承', '逞', '骋', '秤', '吃', '痴', '持', '匙', '池', '迟', '弛', '驰', '耻', '齿', '侈', '尺', '赤', '翅', '斥', '炽', '充', '冲', '虫', '崇', '宠', '抽', '酬', '畴', '踌', '稠', '愁', '筹', '仇', '绸', '瞅', '丑', '臭', '初', '出', '橱', '厨', '躇', '锄', '雏', '滁', '除', '楚', '础', '储', '矗', '搐', '触', '处', '揣', '川', '穿', '椽', '传', '船', '喘', '串', '疮', '窗', '幢', '床', '闯', '创', '吹', '炊', '捶', '锤', '垂', '春', '椿', '醇', '唇', '淳', '纯', '蠢', '戳', '绰', '疵', '茨', '磁', '雌', '辞', '慈', '瓷', '词', '此', '刺', '赐', '次', '聪', '葱', '囱', '匆', '从', '丛', '凑', '粗', '醋', '簇', '促', '蹿', '篡', '窜', '摧', '崔', '催', '脆', '瘁', '粹', '淬', '翠', '村', '存', '寸', '磋', '撮', '搓', '措', '挫', '错'],
      'D': ['搭', '达', '答', '瘩', '打', '大', '呆', '歹', '傣', '戴', '带', '殆', '代', '贷', '袋', '待', '逮', '怠', '耽', '担', '丹', '单', '郸', '掸', '胆', '旦', '氮', '但', '惮', '淡', '诞', '弹', '蛋', '当', '挡', '党', '荡', '档', '刀', '捣', '蹈', '倒', '岛', '祷', '导', '到', '稻', '悼', '道', '盗', '德', '得', '的', '蹬', '灯', '登', '等', '瞪', '凳', '邓', '堤', '低', '滴', '迪', '敌', '笛', '狄', '涤', '翟', '嫡', '抵', '底', '地', '蒂', '第', '帝', '弟', '递', '缔', '颠', '掂', '滇', '碘', '点', '典', '靛', '垫', '电', '佃', '甸', '店', '惦', '奠', '淀', '殿', '碉', '叼', '雕', '凋', '刁', '掉', '吊', '钓', '调', '跌', '爹', '碟', '蝶', '迭', '谍', '叠', '丁', '盯', '叮', '钉', '顶', '鼎', '锭', '定', '订', '丢', '东', '冬', '董', '懂', '动', '栋', '侗', '恫', '冻', '洞', '兜', '抖', '斗', '陡', '豆', '逗', '痘', '都', '督', '毒', '犊', '独', '读', '堵', '睹', '赌', '杜', '镀', '肚', '度', '渡', '妒', '端', '短', '锻', '段', '断', '缎', '堆', '兑', '队', '对', '墩', '吨', '蹲', '敦', '顿', '囤', '钝', '盾', '遁', '掇', '哆', '多', '夺', '垛', '躲', '朵', '跺', '舵', '剁', '惰', '堕'],
      'E': ['蛾', '峨', '鹅', '俄', '额', '讹', '娥', '恶', '厄', '扼', '遏', '鄂', '饿', '恩', '而', '儿', '耳', '尔', '饵', '洱', '二', '贰'],
      'F': ['发', '罚', '筏', '伐', '乏', '阀', '法', '珐', '藩', '帆', '番', '翻', '樊', '矾', '钒', '繁', '凡', '烦', '反', '返', '范', '贩', '犯', '饭', '泛', '坊', '芳', '方', '肪', '房', '防', '妨', '仿', '访', '纺', '放', '菲', '非', '啡', '飞', '肥', '匪', '诽', '吠', '肺', '废', '沸', '费', '芬', '酚', '吩', '氛', '分', '纷', '坟', '焚', '汾', '粉', '奋', '份', '忿', '愤', '粪', '丰', '封', '枫', '蜂', '峰', '锋', '风', '疯', '烽', '逢', '冯', '缝', '讽', '奉', '凤', '佛', '否', '夫', '敷', '肤', '孵', '扶', '拂', '辐', '幅', '氟', '符', '伏', '俘', '服', '浮', '涪', '福', '袱', '弗', '甫', '抚', '辅', '俯', '釜', '斧', '脯', '腑', '府', '腐', '赴', '副', '覆', '赋', '复', '傅', '付', '阜', '父', '腹', '负', '富', '讣', '附', '妇', '缚', '咐'],
      'G': ['噶', '嘎', '该', '改', '概', '钙', '盖', '溉', '干', '甘', '杆', '柑', '竿', '肝', '赶', '感', '秆', '敢', '赣', '冈', '刚', '钢', '缸', '肛', '纲', '岗', '港', '杠', '篙', '皋', '高', '膏', '羔', '糕', '搞', '镐', '稿', '告', '哥', '歌', '搁', '戈', '鸽', '胳', '疙', '割', '革', '葛', '格', '蛤', '阁', '隔', '铬', '个', '各', '给', '根', '跟', '耕', '更', '庚', '羹', '埂', '耿', '梗', '工', '攻', '功', '恭', '龚', '供', '躬', '公', '宫', '弓', '巩', '汞', '拱', '贡', '共', '钩', '勾', '沟', '苟', '狗', '垢', '构', '购', '够', '辜', '菇', '咕', '箍', '估', '沽', '孤', '姑', '鼓', '古', '蛊', '骨', '谷', '股', '故', '顾', '固', '雇', '刮', '瓜', '剐', '寡', '挂', '褂', '乖', '拐', '怪', '棺', '关', '官', '冠', '观', '管', '馆', '罐', '惯', '灌', '贯', '光', '广', '逛', '瑰', '规', '圭', '硅', '归', '龟', '闺', '轨', '鬼', '诡', '癸', '桂', '柜', '跪', '贵', '刽', '辊', '滚', '棍', '锅', '郭', '国', '果', '裹', '过'],
      'H': ['哈', '骸', '孩', '海', '氦', '亥', '害', '骇', '酣', '憨', '邯', '韩', '含', '涵', '寒', '函', '喊', '罕', '翰', '撼', '捍', '旱', '憾', '悍', '焊', '汗', '汉', '夯', '杭', '航', '壕', '嚎', '豪', '毫', '郝', '好', '耗', '号', '浩', '呵', '喝', '荷', '菏', '核', '禾', '和', '何', '合', '盒', '貉', '阂', '河', '涸', '赫', '褐', '鹤', '贺', '嘿', '黑', '痕', '很', '狠', '恨', '哼', '亨', '横', '衡', '恒', '轰', '哄', '烘', '虹', '鸿', '洪', '宏', '弘', '红', '喉', '侯', '猴', '吼', '厚', '候', '后', '呼', '乎', '忽', '瑚', '壶', '葫', '胡', '蝴', '狐', '糊', '湖', '弧', '虎', '唬', '护', '互', '沪', '户', '花', '哗', '华', '猾', '滑', '画', '划', '化', '话', '槐', '徊', '怀', '淮', '坏', '欢', '环', '桓', '还', '缓', '换', '患', '唤', '痪', '豢', '焕', '涣', '宦', '幻', '荒', '慌', '黄', '磺', '蝗', '簧', '皇', '凰', '惶', '煌', '晃', '幌', '恍', '谎', '灰', '挥', '辉', '徽', '恢', '蛔', '回', '毁', '悔', '慧', '卉', '惠', '晦', '贿', '秽', '会', '烩', '汇', '讳', '诲', '绘', '荤', '昏', '婚', '魂', '浑', '混', '豁', '活', '伙', '火', '获', '或', '惑', '霍', '货', '祸', '泓'],
      'J': ['击', '圾', '基', '机', '畸', '稽', '积', '箕', '肌', '饥', '迹', '激', '讥', '鸡', '姬', '绩', '缉', '吉', '极', '棘', '辑', '籍', '集', '及', '急', '疾', '汲', '即', '嫉', '级', '挤', '几', '脊', '己', '蓟', '技', '冀', '季', '伎', '祭', '剂', '悸', '济', '寄', '寂', '计', '记', '既', '忌', '际', '妓', '继', '纪', '嘉', '枷', '夹', '佳', '家', '加', '荚', '颊', '贾', '甲', '钾', '假', '稼', '价', '架', '驾', '嫁', '歼', '监', '坚', '尖', '笺', '间', '煎', '兼', '肩', '艰', '奸', '缄', '茧', '检', '柬', '碱', '硷', '拣', '捡', '简', '俭', '剪', '减', '荐', '槛', '鉴', '践', '贱', '见', '键', '箭', '件', '健', '舰', '剑', '饯', '渐', '溅', '涧', '建', '僵', '姜', '将', '浆', '江', '疆', '蒋', '桨', '奖', '讲', '匠', '酱', '降', '蕉', '椒', '礁', '焦', '胶', '交', '郊', '浇', '骄', '娇', '嚼', '搅', '铰', '矫', '侥', '脚', '狡', '角', '饺', '缴', '绞', '剿', '教', '酵', '轿', '较', '叫', '窖', '揭', '接', '皆', '秸', '街', '阶', '截', '劫', '节', '桔', '杰', '捷', '睫', '竭', '洁', '结', '解', '姐', '戒', '藉', '芥', '界', '借', '介', '疥', '诫', '届', '巾', '筋', '斤', '金', '今', '津', '襟', '紧', '锦', '仅', '谨', '进', '靳', '晋', '禁', '近', '烬', '浸', '尽', '劲', '荆', '兢', '茎', '睛', '晶', '鲸', '京', '惊', '精', '粳', '经', '井', '警', '景', '颈', '静', '境', '敬', '镜', '径', '痉', '靖', '竟', '竞', '净', '炯', '窘', '揪', '究', '纠', '玖', '韭', '久', '灸', '九', '酒', '厩', '救', '旧', '臼', '舅', '咎', '就', '疚', '鞠', '拘', '狙', '疽', '居', '驹', '菊', '局', '咀', '矩', '举', '沮', '聚', '拒', '据', '巨', '具', '距', '踞', '锯', '俱', '句', '惧', '炬', '剧', '捐', '鹃', '娟', '倦', '眷', '卷', '绢', '撅', '攫', '抉', '掘', '倔', '爵', '觉', '决', '诀', '绝', '均', '菌', '钧', '军', '君', '峻', '俊', '竣', '浚', '郡', '骏'],
      'K': ['喀', '咖', '卡', '咯', '开', '揩', '楷', '凯', '慨', '刊', '堪', '勘', '坎', '砍', '看', '康', '慷', '糠', '扛', '抗', '亢', '炕', '考', '拷', '烤', '靠', '坷', '苛', '柯', '棵', '磕', '颗', '科', '壳', '咳', '可', '渴', '克', '刻', '客', '课', '肯', '啃', '垦', '恳', '坑', '吭', '空', '恐', '孔', '控', '抠', '口', '扣', '寇', '枯', '哭', '窟', '苦', '酷', '库', '裤', '夸', '垮', '挎', '跨', '胯', '块', '筷', '侩', '快', '宽', '款', '匡', '筐', '狂', '框', '矿', '眶', '旷', '况', '亏', '盔', '岿', '窥', '葵', '奎', '魁', '傀', '馈', '愧', '溃', '坤', '昆', '捆', '困', '括', '扩', '廓', '阔'],
      'L': ['垃', '拉', '喇', '蜡', '腊', '辣', '啦', '莱', '来', '赖', '蓝', '婪', '栏', '拦', '篮', '阑', '兰', '澜', '谰', '揽', '览', '懒', '缆', '烂', '滥', '琅', '榔', '狼', '廊', '郎', '朗', '浪', '捞', '劳', '牢', '老', '佬', '姥', '酪', '烙', '涝', '勒', '乐', '雷', '镭', '蕾', '磊', '累', '儡', '垒', '擂', '肋', '类', '泪', '棱', '楞', '冷', '厘', '梨', '犁', '黎', '篱', '狸', '离', '漓', '理', '李', '里', '鲤', '礼', '莉', '荔', '吏', '栗', '丽', '厉', '励', '砾', '历', '利', '傈', '例', '俐', '痢', '立', '粒', '沥', '隶', '力', '璃', '哩', '俩', '联', '莲', '连', '镰', '廉', '怜', '涟', '帘', '敛', '脸', '链', '恋', '炼', '练', '粮', '凉', '梁', '粱', '良', '两', '辆', '量', '晾', '亮', '谅', '撩', '聊', '僚', '疗', '燎', '寥', '辽', '潦', '了', '撂', '镣', '廖', '料', '列', '裂', '烈', '劣', '猎', '琳', '林', '磷', '霖', '临', '邻', '鳞', '淋', '凛', '赁', '吝', '拎', '玲', '菱', '零', '龄', '铃', '伶', '羚', '凌', '灵', '陵', '岭', '领', '另', '令', '溜', '琉', '榴', '硫', '馏', '留', '刘', '瘤', '流', '柳', '六', '龙', '聋', '咙', '笼', '窿', '隆', '垄', '拢', '陇', '楼', '娄', '搂', '篓', '漏', '陋', '芦', '卢', '颅', '庐', '炉', '掳', '卤', '虏', '鲁', '麓', '碌', '露', '路', '赂', '鹿', '潞', '禄', '录', '陆', '戮', '驴', '吕', '铝', '侣', '旅', '履', '屡', '缕', '虑', '氯', '律', '率', '滤', '绿', '峦', '挛', '孪', '滦', '卵', '乱', '掠', '略', '抡', '轮', '伦', '仑', '沦', '纶', '论'],
      'M': ['妈', '麻', '玛', '码', '蚂', '马', '骂', '嘛', '吗', '埋', '买', '麦', '卖', '迈', '脉', '瞒', '馒', '蛮', '满', '蔓', '曼', '慢', '漫', '谩', '芒', '茫', '盲', '氓', '忙', '莽', '猫', '茅', '锚', '毛', '矛', '铆', '卯', '茂', '冒', '帽', '貌', '贸', '么', '玫', '枚', '梅', '酶', '霉', '煤', '没', '眉', '媒', '镁', '每', '美', '味', '寐', '媚', '妹', '门', '闷', '们', '萌', '蒙', '檬', '盟', '锰', '猛', '梦', '孟', '眯', '醚', '靡', '糜', '迷', '谜', '弥', '米', '秘', '觅', '泌', '蜜', '密', '幂', '棉', '眠', '绵', '冕', '免', '勉', '娩', '缅', '面', '苗', '描', '瞄', '藐', '秒', '渺', '庙', '妙', '蔑', '灭', '民', '抿', '皿', '敏', '悯', '闽', '明', '螟', '鸣', '铭', '名', '命', '谬', '摸', '摹', '蘑', '模', '膜', '磨', '摩', '魔', '抹', '末', '莫', '墨', '默', '沫', '漠', '寞', '陌', '谋', '某', '拇', '牡', '亩', '姆', '母', '墓', '暮', '幕', '募', '慕', '木', '目', '睦', '牧', '穆'],
      'N': ['拿', '哪', '呐', '钠', '那', '娜', '纳', '氖', '乃', '奶', '耐', '奈', '南', '男', '难', '囊', '挠', '脑', '恼', '闹', '淖', '呢', '馁', '内', '嫩', '能', '妮', '霓', '倪', '泥', '尼', '拟', '你', '匿', '腻', '逆', '溺', '蔫', '拈', '年', '碾', '撵', '捻', '念', '娘', '酿', '鸟', '尿', '捏', '聂', '孽', '啮', '镊', '镍', '涅', '您', '柠', '狞', '凝', '宁', '拧', '泞', '牛', '扭', '钮', '纽', '脓', '浓', '农', '弄', '奴', '努', '怒', '女', '暖', '虐', '疟', '挪', '懦', '糯', '诺'],
      'O': ['哦', '欧', '鸥', '殴', '藕', '呕', '偶', '沤'],
      'P': ['啪', '趴', '爬', '帕', '怕', '琶', '拍', '排', '牌', '徘', '湃', '派', '攀', '潘', '盘', '磐', '盼', '畔', '判', '叛', '乓', '庞', '旁', '耪', '胖', '抛', '咆', '刨', '炮', '袍', '跑', '泡', '呸', '胚', '培', '裴', '赔', '陪', '配', '佩', '沛', '喷', '盆', '砰', '抨', '烹', '澎', '彭', '蓬', '棚', '硼', '篷', '膨', '朋', '鹏', '捧', '碰', '坯', '砒', '霹', '批', '披', '劈', '琵', '毗', '啤', '脾', '疲', '皮', '匹', '痞', '僻', '屁', '譬', '篇', '偏', '片', '骗', '飘', '漂', '瓢', '票', '撇', '瞥', '拼', '频', '贫', '品', '聘', '乒', '坪', '苹', '萍', '平', '凭', '瓶', '评', '屏', '坡', '泼', '颇', '婆', '破', '魄', '迫', '粕', '剖', '扑', '铺', '仆', '莆', '葡', '菩', '蒲', '埔', '朴', '圃', '普', '浦', '谱', '曝', '瀑'],
      'Q': ['期', '欺', '栖', '戚', '妻', '七', '凄', '漆', '柒', '沏', '其', '棋', '奇', '歧', '畦', '崎', '脐', '齐', '旗', '祈', '祁', '骑', '起', '岂', '乞', '企', '启', '契', '砌', '器', '气', '迄', '弃', '汽', '泣', '讫', '掐', '恰', '洽', '牵', '扦', '钎', '铅', '千', '迁', '签', '仟', '谦', '乾', '黔', '钱', '钳', '前', '潜', '遣', '浅', '谴', '堑', '嵌', '欠', '歉', '枪', '呛', '腔', '羌', '墙', '蔷', '强', '抢', '橇', '锹', '敲', '悄', '桥', '瞧', '乔', '侨', '巧', '鞘', '撬', '翘', '峭', '俏', '窍', '切', '茄', '且', '怯', '窃', '钦', '侵', '亲', '秦', '琴', '勤', '芹', '擒', '禽', '寝', '沁', '青', '轻', '氢', '倾', '卿', '清', '擎', '晴', '氰', '情', '顷', '请', '庆', '琼', '穷', '秋', '丘', '邱', '球', '求', '囚', '酋', '泅', '趋', '区', '蛆', '曲', '躯', '屈', '驱', '渠', '取', '娶', '龋', '趣', '去', '圈', '颧', '权', '醛', '泉', '全', '痊', '拳', '犬', '券', '劝', '缺', '炔', '瘸', '却', '鹊', '榷', '确', '雀', '裙', '群'],
      'R': ['然', '燃', '冉', '染', '瓤', '壤', '攘', '嚷', '让', '饶', '扰', '绕', '惹', '热', '壬', '仁', '人', '忍', '韧', '任', '认', '刃', '妊', '纫', '扔', '仍', '日', '戎', '茸', '蓉', '荣', '融', '熔', '溶', '容', '绒', '冗', '揉', '柔', '肉', '茹', '蠕', '儒', '孺', '如', '辱', '乳', '汝', '入', '褥', '软', '阮', '蕊', '瑞', '锐', '闰', '润', '若', '弱'],
      'S': ['撒', '洒', '萨', '腮', '鳃', '塞', '赛', '三', '叁', '伞', '散', '桑', '嗓', '丧', '搔', '骚', '扫', '嫂', '瑟', '色', '涩', '森', '僧', '莎', '砂', '杀', '刹', '沙', '纱', '傻', '啥', '煞', '筛', '晒', '珊', '苫', '杉', '山', '删', '煽', '衫', '闪', '陕', '赡', '汕', '善', '单', '扇', '缮', '墒', '伤', '商', '赏', '晌', '上', '尚', '裳', '梢', '捎', '稍', '烧', '芍', '勺', '韶', '少', '哨', '邵', '绍', '奢', '赊', '蛇', '舌', '舍', '赦', '摄', '射', '慑', '涉', '社', '设', '砷', '申', '呻', '伸', '身', '深', '娠', '绅', '神', '沈', '审', '婶', '甚', '肾', '慎', '渗', '声', '生', '甥', '牲', '升', '绳', '省', '盛', '剩', '胜', '圣', '师', '失', '狮', '施', '湿', '诗', '尸', '虱', '十', '石', '拾', '时', '什', '食', '蚀', '实', '识', '史', '矢', '使', '屎', '驶', '始', '式', '示', '士', '世', '柿', '事', '拭', '誓', '逝', '势', '是', '嗜', '噬', '适', '仕', '侍', '释', '饰', '氏', '市', '恃', '室', '视', '试', '收', '手', '首', '守', '寿', '授', '售', '受', '瘦', '兽', '蔬', '枢', '梳', '殊', '抒', '输', '叔', '舒', '淑', '疏', '书', '赎', '孰', '熟', '薯', '暑', '曙', '署', '蜀', '黍', '鼠', '属', '术', '述', '树', '束', '戍', '竖', '墅', '庶', '数', '漱', '恕', '刷', '耍', '摔', '衰', '甩', '帅', '栓', '拴', '霜', '双', '爽', '谁', '水', '睡', '税', '吮', '瞬', '顺', '舜', '说', '硕', '朔', '烁', '斯', '撕', '嘶', '思', '私', '司', '丝', '死', '肆', '寺', '嗣', '四', '伺', '似', '饲', '已', '松', '耸', '怂', '颂', '送', '宋', '讼', '诵', '搜', '艘', '擞', '嗽', '苏', '酥', '俗', '素', '速', '粟', '僳', '塑', '溯', '宿', '诉', '肃', '酸', '蒜', '算', '虽', '隋', '随', '绥', '髓', '碎', '岁', '穗', '遂', '隧', '祟', '孙', '损', '笋', '蓑', '梭', '唆', '缩', '琐', '索', '锁', '所'],
      'T': ['塌', '他', '它', '她', '塔', '獭', '挞', '蹋', '踏', '胎', '苔', '抬', '台', '泰', '酞', '太', '态', '汰', '坍', '摊', '贪', '瘫', '滩', '坛', '檀', '痰', '潭', '谭', '谈', '坦', '毯', '袒', '碳', '探', '叹', '炭', '汤', '塘', '搪', '堂', '棠', '膛', '唐', '糖', '倘', '躺', '淌', '趟', '烫', '掏', '涛', '滔', '绦', '萄', '桃', '逃', '淘', '陶', '讨', '套', '特', '藤', '腾', '疼', '誊', '梯', '剔', '踢', '锑', '提', '题', '蹄', '啼', '体', '替', '嚏', '惕', '涕', '剃', '屉', '天', '添', '填', '田', '甜', '恬', '舔', '腆', '挑', '条', '迢', '眺', '跳', '贴', '铁', '帖', '厅', '听', '烃', '汀', '廷', '停', '亭', '庭', '挺', '艇', '通', '桐', '酮', '瞳', '同', '铜', '彤', '童', '桶', '捅', '筒', '统', '痛', '偷', '投', '头', '透', '凸', '秃', '突', '图', '徒', '途', '涂', '屠', '土', '吐', '兔', '湍', '团', '推', '颓', '腿', '蜕', '褪', '退', '吞', '屯', '臀', '拖', '托', '脱', '鸵', '陀', '驮', '驼', '椭', '妥', '拓', '唾'],
      'W': ['挖', '哇', '蛙', '洼', '娃', '瓦', '袜', '歪', '外', '豌', '弯', '湾', '玩', '顽', '丸', '烷', '完', '碗', '挽', '晚', '皖', '惋', '宛', '婉', '万', '腕', '汪', '王', '亡', '枉', '网', '往', '旺', '望', '忘', '妄', '威', '巍', '微', '危', '韦', '违', '桅', '围', '唯', '惟', '为', '潍', '维', '苇', '萎', '委', '伟', '伪', '尾', '纬', '未', '蔚', '味', '畏', '胃', '喂', '魏', '位', '渭', '谓', '尉', '慰', '卫', '瘟', '温', '蚊', '文', '闻', '纹', '吻', '稳', '紊', '问', '嗡', '翁', '瓮', '挝', '蜗', '涡', '窝', '我', '斡', '卧', '握', '沃', '巫', '呜', '钨', '乌', '污', '诬', '屋', '无', '芜', '梧', '吾', '吴', '毋', '武', '五', '捂', '午', '舞', '伍', '侮', '坞', '戊', '雾', '晤', '物', '勿', '务', '悟', '误'],
      'X': ['昔', '熙', '析', '西', '硒', '矽', '晰', '嘻', '吸', '锡', '牺', '稀', '息', '希', '悉', '膝', '夕', '惜', '熄', '烯', '溪', '汐', '犀', '檄', '袭', '席', '习', '媳', '喜', '铣', '洗', '系', '隙', '戏', '细', '瞎', '虾', '匣', '霞', '辖', '暇', '峡', '侠', '狭', '下', '厦', '夏', '吓', '掀', '锨', '先', '仙', '鲜', '纤', '咸', '贤', '衔', '舷', '闲', '涎', '弦', '嫌', '显', '险', '现', '献', '县', '腺', '馅', '羡', '宪', '陷', '限', '线', '相', '厢', '镶', '香', '箱', '襄', '湘', '乡', '翔', '祥', '详', '想', '响', '享', '项', '巷', '橡', '像', '向', '象', '萧', '硝', '霄', '削', '哮', '嚣', '销', '消', '宵', '淆', '晓', '小', '孝', '校', '肖', '啸', '笑', '效', '楔', '些', '歇', '蝎', '鞋', '协', '挟', '携', '邪', '斜', '胁', '谐', '写', '械', '卸', '蟹', '懈', '泄', '泻', '谢', '屑', '薪', '芯', '锌', '欣', '辛', '新', '忻', '心', '信', '衅', '星', '腥', '猩', '惺', '兴', '刑', '型', '形', '邢', '行', '醒', '幸', '杏', '性', '姓', '兄', '凶', '胸', '匈', '汹', '雄', '熊', '休', '修', '羞', '朽', '嗅', '锈', '秀', '袖', '绣', '墟', '戌', '需', '虚', '嘘', '须', '徐', '许', '蓄', '酗', '叙', '旭', '序', '畜', '恤', '絮', '婿', '绪', '续'],
      'Y': ['轩', '喧', '宣', '悬', '旋', '玄', '选', '癣', '眩', '绚', '靴', '薛', '学', '穴', '雪', '血', '勋', '熏', '循', '旬', '询', '寻', '驯', '巡', '殉', '汛', '训', '讯', '逊', '迅', '压', '押', '鸦', '鸭', '呀', '丫', '芽', '牙', '蚜', '崖', '衙', '涯', '雅', '哑', '亚', '讶', '焉', '咽', '阉', '烟', '淹', '盐', '严', '研', '蜒', '岩', '延', '言', '颜', '阎', '炎', '沿', '奄', '掩', '眼', '衍', '演', '艳', '堰', '燕', '厌', '砚', '雁', '唁', '彦', '焰', '宴', '谚', '验', '殃', '央', '鸯', '秧', '杨', '扬', '佯', '疡', '羊', '洋', '阳', '氧', '仰', '痒', '养', '样', '漾', '邀', '腰', '妖', '瑶', '摇', '尧', '遥', '窑', '谣', '姚', '咬', '舀', '药', '要', '耀', '椰', '噎', '耶', '爷', '野', '冶', '也', '页', '掖', '业', '叶', '曳', '腋', '夜', '液', '一', '壹', '医', '揖', '铱', '依', '伊', '衣', '颐', '夷', '遗', '移', '仪', '胰', '疑', '沂', '宜', '姨', '彝', '椅', '蚁', '倚', '已', '乙', '矣', '以', '艺', '抑', '易', '邑', '屹', '亿', '役', '臆', '逸', '肄', '疫', '亦', '裔', '意', '毅', '忆', '义', '益', '溢', '诣', '议', '谊', '译', '异', '翼', '翌', '绎', '茵', '荫', '因', '殷', '音', '阴', '姻', '吟', '银', '淫', '寅', '饮', '尹', '引', '隐', '印', '英', '樱', '婴', '鹰', '应', '缨', '莹', '萤', '营', '荧', '蝇', '迎', '赢', '盈', '影', '颖', '硬', '映', '哟', '拥', '佣', '臃', '痈', '庸', '雍', '踊', '蛹', '咏', '泳', '涌', '永', '恿', '勇', '用', '幽', '优', '悠', '忧', '尤', '由', '邮', '铀', '犹', '油', '游', '酉', '有', '友', '右', '佑', '釉', '诱', '又', '幼', '迂', '淤', '于', '盂', '榆', '虞', '愚', '舆', '余', '俞', '逾', '鱼', '愉', '渝', '渔', '隅', '予', '娱', '雨', '与', '屿', '禹', '宇', '语', '羽', '玉', '域', '芋', '郁', '吁', '遇', '喻', '峪', '御', '愈', '欲', '狱', '育', '誉', '浴', '寓', '裕', '预', '豫', '驭', '鸳', '渊', '冤', '元', '垣', '袁', '原', '援', '辕', '园', '员', '圆', '猿', '源', '缘', '远', '苑', '愿', '怨', '院', '曰', '约', '越', '跃', '钥', '岳', '粤', '月', '悦', '阅', '耘', '云', '郧', '匀', '陨', '允', '运', '蕴', '酝', '晕', '韵', '孕'],
      'Z': ['匝', '砸', '杂', '栽', '哉', '灾', '宰', '载', '再', '在', '咱', '攒', '暂', '赞', '赃', '脏', '葬', '遭', '糟', '凿', '藻', '枣', '早', '澡', '蚤', '躁', '噪', '造', '皂', '灶', '燥', '责', '择', '则', '泽', '贼', '怎', '增', '憎', '曾', '赠', '扎', '喳', '渣', '札', '轧', '铡', '闸', '眨', '栅', '榨', '咋', '乍', '炸', '诈', '摘', '斋', '宅', '窄', '债', '寨', '瞻', '毡', '詹', '粘', '沾', '盏', '斩', '辗', '崭', '展', '蘸', '栈', '占', '战', '站', '湛', '绽', '樟', '章', '彰', '漳', '张', '掌', '涨', '杖', '丈', '帐', '账', '仗', '胀', '瘴', '障', '招', '昭', '找', '沼', '赵', '照', '罩', '兆', '肇', '召', '遮', '折', '哲', '蛰', '辙', '者', '锗', '蔗', '这', '浙', '珍', '斟', '真', '甄', '砧', '臻', '贞', '针', '侦', '枕', '疹', '诊', '震', '振', '镇', '阵', '蒸', '挣', '睁', '铮', '征', '狰', '争', '怔', '整', '拯', '正', '政', '帧', '症', '郑', '证', '芝', '枝', '支', '吱', '蜘', '知', '肢', '脂', '汁', '之', '织', '职', '直', '植', '殖', '执', '值', '侄', '址', '指', '止', '趾', '只', '旨', '纸', '志', '挚', '掷', '至', '致', '置', '帜', '峙', '制', '智', '秩', '稚', '质', '炙', '痔', '滞', '治', '窒', '中', '盅', '忠', '钟', '衷', '终', '种', '肿', '重', '仲', '众', '舟', '周', '州', '洲', '诌', '粥', '轴', '肘', '帚', '咒', '皱', '宙', '昼', '骤', '珠', '株', '蛛', '朱', '猪', '诸', '诛', '逐', '竹', '烛', '煮', '拄', '瞩', '嘱', '主', '著', '柱', '助', '蛀', '贮', '铸', '筑', '住', '注', '祝', '驻', '抓', '爪', '拽', '专', '砖', '转', '撰', '赚', '篆', '桩', '庄', '装', '妆', '撞', '壮', '状', '椎', '锥', '追', '赘', '坠', '缀', '谆', '准', '捉', '拙', '卓', '桌', '琢', '茁', '酌', '啄', '着', '灼', '浊', '兹', '咨', '资', '姿', '滋', '淄', '孜', '紫', '仔', '籽', '滓', '子', '自', '渍', '字', '鬃', '棕', '踪', '宗', '综', '总', '纵', '邹', '走', '奏', '揍', '租', '足', '卒', '族', '祖', '诅', '阻', '组', '钻', '纂', '嘴', '醉', '最', '罪', '尊', '遵', '昨', '左', '佐', '柞', '做', '作', '坐', '座']
    }
    
    // 构建反向映射表：中文字符 -> 拼音首字母
    const pinyinMapReverse = {}
    Object.keys(pinyinMap).forEach(letter => {
      pinyinMap[letter].forEach(char => {
        pinyinMapReverse[char] = letter
      })
    })

    let result = ''
    for (let i = 0; i < str.length; i++) {
      const char = str[i]
      // 判断是否为中文字符（Unicode范围：\u4e00-\u9fa5）
      if (/[\u4e00-\u9fa5]/.test(char)) {
        // 查找拼音首字母
        const firstLetter = pinyinMapReverse[char]
        if (firstLetter) {
          result += firstLetter
        } else {
          // 如果找不到映射，保留原字符，避免信息丢失
          result += char
        }
      } else {
        // 非中文字符保持原样
        result += char
      }
    }
    return result
  },

  // 四舍五入函数
  cmRound(number, decimals = 0) {
    const num = Number(number)
    if (isNaN(num)) {
      return 0
    }
    return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals)
  },

  // 向上取整函数
  cmCeil(number) {
    const num = Number(number)
    if (isNaN(num)) {
      return 0
    }
    return Math.ceil(num)
  },

  // 向下取整函数
  cmFloor(number) {
    const num = Number(number)
    if (isNaN(num)) {
      return 0
    }
    return Math.floor(num)
  },

  // 随机数生成函数
  cmRandom(min, max) {
    const minNum = Number(min) || 0
    const maxNum = Number(max) || 100
    return Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum
  },

  // 随机字符串生成函数
  cmRandomString(length = 32) {
    const len = Number(length) || 32
    const chars = '0123456789abcdefghijklmnopqrstuvwxyz'
    let result = ''
    for (let i = 0; i < len; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length)
      result += chars[randomIndex]
    }
    return result
  },

  // 百分比计算函数
  cmPercent(value, total, decimals = 2) {
    const val = Number(value) || 0
    const tot = Number(total) || 1
    const percent = (val / tot) * 100
    return this.cmRound(percent, decimals) + '%'
  },

  // 身份证号码验证函数
  cmValidateIdCard(idCard) {
    if (!idCard || typeof idCard !== 'string') {
      return false
    }
    
    // 18位身份证号码正则表达式
    const reg18 = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    
    if (!reg18.test(idCard)) {
      return false
    }
    
    // 校验码验证
    const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
    
    let sum = 0
    for (let i = 0; i < 17; i++) {
      sum += parseInt(idCard[i]) * weights[i]
    }
    
    const checkCode = checkCodes[sum % 11]
    return idCard[17].toUpperCase() === checkCode
  },

  // 从身份证号获取年龄
  cmGetAgeFromIdCard(idCard) {
    if (!this.cmValidateIdCard(idCard)) {
      return 0
    }
    
    const birthYear = parseInt(idCard.substring(6, 10))
    const birthMonth = parseInt(idCard.substring(10, 12))
    const birthDay = parseInt(idCard.substring(12, 14))
    
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth() + 1
    const currentDay = today.getDate()
    
    let age = currentYear - birthYear
    
    // 如果还没到生日，年龄减1
    if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
      age--
    }
    
    return age
  },

  // 从身份证号获取性别
  cmGetGenderFromIdCard(idCard) {
    if (!this.cmValidateIdCard(idCard)) {
      return '未知'
    }
    
    const genderCode = parseInt(idCard.substring(16, 17))
    return genderCode % 2 === 0 ? '女' : '男'
  },

  // 从身份证号获取出生日期
  cmGetBirthDateFromIdCard(idCard) {
    // 先检查身份证号码格式
    if (!idCard || typeof idCard !== 'string') {
      return '身份证号码为空'
    }
    
    if (idCard.length !== 18) {
      return '身份证号码长度不正确'
    }
    
    // 即使验证失败，也尝试提取出生日期（用于调试）
    const year = idCard.substring(6, 10)
    const month = idCard.substring(10, 12)
    const day = idCard.substring(12, 14)
    
    // 检查日期是否合理
    if (year < 1900 || year > 2100) {
      return '出生年份不合理'
    }
    
    if (month < 1 || month > 12) {
      return '出生月份不合理'
    }
    
    if (day < 1 || day > 31) {
      return '出生日期不合理'
    }
    
    return `${year}-${month}-${day}`
  },

  // 从身份证号获取地区信息
  cmGetRegionFromIdCard(idCard) {
    if (!this.cmValidateIdCard(idCard)) {
      return '未知'
    }
    
    const regionCode = idCard.substring(0, 6)
    
    // 省份代码映射
    const provinceMap = {
      '11': '北京市',
      '12': '天津市',
      '13': '河北省',
      '14': '山西省',
      '15': '内蒙古自治区',
      '21': '辽宁省',
      '22': '吉林省',
      '23': '黑龙江省',
      '31': '上海市',
      '32': '江苏省',
      '33': '浙江省',
      '34': '安徽省',
      '35': '福建省',
      '36': '江西省',
      '37': '山东省',
      '41': '河南省',
      '42': '湖北省',
      '43': '湖南省',
      '44': '广东省',
      '45': '广西壮族自治区',
      '46': '海南省',
      '50': '重庆市',
      '51': '四川省',
      '52': '贵州省',
      '53': '云南省',
      '54': '西藏自治区',
      '61': '陕西省',
      '62': '甘肃省',
      '63': '青海省',
      '64': '宁夏回族自治区',
      '65': '新疆维吾尔自治区',
      '71': '台湾省',
      '81': '香港特别行政区',
      '82': '澳门特别行政区'
    }
    
    const provinceCode = regionCode.substring(0, 2)
    return provinceMap[provinceCode] || '未知地区'
  },

  // 从身份证号获取完整信息
  cmGetIdCardInfo(idCard) {
    if (!this.cmValidateIdCard(idCard)) {
      return {
        valid: false,
        age: 0,
        gender: '未知',
        birthDate: '',
        region: '未知'
      }
    }
    
    return {
      valid: true,
      age: this.cmGetAgeFromIdCard(idCard),
      gender: this.cmGetGenderFromIdCard(idCard),
      birthDate: this.cmGetBirthDateFromIdCard(idCard),
      region: this.cmGetRegionFromIdCard(idCard)
    }
  },

  // 条件评估辅助函数：判断行数据是否符合条件
  // rowValue: 行的字段值
  // conditionValue: 条件值
  // operator: 比较操作符，默认为 "=="
  _evaluateTableCondition(rowValue, conditionValue, operator) {
    const op = operator || '=='
    
    // 判断值是否为空（null、undefined、空字符串都视为空）
    const isValueEmpty = conditionValue === null || conditionValue === undefined || conditionValue === ''
    const isFieldEmpty = rowValue === null || rowValue === undefined || rowValue === ''
    
    switch (op) {
      case '==':
        // 如果比较值是空，则检查字段值是否也为空
        if (isValueEmpty) {
          return isFieldEmpty
        }
        return String(rowValue) === String(conditionValue)
      case '!=':
        // 如果比较值是空，则检查字段值是否不为空
        if (isValueEmpty) {
          return !isFieldEmpty
        }
        return String(rowValue) !== String(conditionValue)
      case 'contains':
        // 如果字段值为空，无法包含任何内容
        if (isFieldEmpty) {
          return false
        }
        return String(rowValue).includes(String(conditionValue))
      case 'not_contains':
        // 如果字段值为空，不包含任何内容，返回true
        if (isFieldEmpty) {
          return true
        }
        return !String(rowValue).includes(String(conditionValue))
      case 'startsWith':
        // 如果字段值为空，无法以任何内容开头
        if (isFieldEmpty) {
          return false
        }
        return String(rowValue).startsWith(String(conditionValue))
      case 'endsWith':
        // 如果字段值为空，无法以任何内容结尾
        if (isFieldEmpty) {
          return false
        }
        return String(rowValue).endsWith(String(conditionValue))
      case '>':
        // 如果字段值为空，无法进行数值比较
        if (isFieldEmpty) {
          return false
        }
        return Number(rowValue) > Number(conditionValue)
      case '>=':
        // 如果字段值为空，无法进行数值比较
        if (isFieldEmpty) {
          return false
        }
        return Number(rowValue) >= Number(conditionValue)
      case '<':
        // 如果字段值为空，无法进行数值比较
        if (isFieldEmpty) {
          return false
        }
        return Number(rowValue) < Number(conditionValue)
      case '<=':
        // 如果字段值为空，无法进行数值比较
        if (isFieldEmpty) {
          return false
        }
        return Number(rowValue) <= Number(conditionValue)
      case 'is_empty':
        return isFieldEmpty
      case 'is_not_empty':
        return !isFieldEmpty
      default:
        // 默认使用 == 比较
        if (isValueEmpty) {
          return isFieldEmpty
        }
        return String(rowValue) === String(conditionValue)
    }
  },

  // 表格查找函数：从表格中查找符合条件的行，返回指定字段的值
  // tableData: 表格数据（JSON字符串或数组）
  // conditionField: 筛选条件的字段名
  // conditionValue: 筛选条件的值
  // targetField: 要返回的字段名（可选，如果不提供则返回整行数据的JSON字符串）
  // operator: 比较操作符（可选，默认为"=="），支持：==（等于）、!=（不等于）、>（大于）、>=（大于等于）、<（小于）、<=（小于等于）、contains（包含）、not_contains（不包含）、startsWith（以...开头）、endsWith（以...结尾）、is_empty（为空）、is_not_empty（不为空）
  cmTableFind(tableData, conditionField, conditionValue, targetField, operator) {
    try {
      // 解析表格数据
      let parsedData = tableData
      if (typeof tableData === 'string') {
        try {
          parsedData = JSON.parse(tableData)
        } catch (e) {
          // 如果解析失败，尝试再次解析（可能是双重JSON字符串）
          try {
            parsedData = JSON.parse(JSON.parse(tableData))
          } catch (e2) {
            return ''
          }
        }
      }

      if (!Array.isArray(parsedData) || parsedData.length === 0) {
        return ''
      }

      // 查找符合条件的行
      const foundRow = parsedData.find(row => {
        const rowValue = row[conditionField]
        return this._evaluateTableCondition(rowValue, conditionValue, operator)
      })

      if (!foundRow) {
        return ''
      }

      // 如果指定了目标字段，返回该字段的值；否则返回整行数据的JSON字符串
      if (targetField) {
        return foundRow[targetField] !== undefined ? foundRow[targetField] : ''
      } else {
        return JSON.stringify(foundRow)
      }
    } catch (error) {
      console.warn('cmTableFind 错误:', error)
      return ''
    }
  },

  // 表格查找行函数：从表格中查找符合条件的行，返回整行数据
  // tableData: 表格数据（JSON字符串或数组）
  // conditionField: 筛选条件的字段名
  // conditionValue: 筛选条件的值
  // operator: 比较操作符（可选，默认为"=="），支持：==（等于）、!=（不等于）、>（大于）、>=（大于等于）、<（小于）、<=（小于等于）、contains（包含）、not_contains（不包含）、startsWith（以...开头）、endsWith（以...结尾）、is_empty（为空）、is_not_empty（不为空）
  cmTableFindRow(tableData, conditionField, conditionValue, operator) {
    return this.cmTableFind(tableData, conditionField, conditionValue, null, operator)
  },

  // 表格计数函数：统计表格中符合条件的行数
  // tableData: 表格数据（JSON字符串或数组）
  // conditionField: 筛选条件的字段名
  // conditionValue: 筛选条件的值
  // operator: 比较操作符（可选，默认为"=="），支持：==（等于）、!=（不等于）、>（大于）、>=（大于等于）、<（小于）、<=（小于等于）、contains（包含）、not_contains（不包含）、startsWith（以...开头）、endsWith（以...结尾）、is_empty（为空）、is_not_empty（不为空）
  cmTableCount(tableData, conditionField, conditionValue, operator) {
    try {
      // 解析表格数据
      let parsedData = tableData
      if (typeof tableData === 'string') {
        try {
          parsedData = JSON.parse(tableData)
        } catch (e) {
          // 如果解析失败，尝试再次解析（可能是双重JSON字符串）
          try {
            parsedData = JSON.parse(JSON.parse(tableData))
          } catch (e2) {
            return 0
          }
        }
      }

      if (!Array.isArray(parsedData) || parsedData.length === 0) {
        return 0
      }

      // 统计符合条件的行数
      const count = parsedData.filter(row => {
        const rowValue = row[conditionField]
        return this._evaluateTableCondition(rowValue, conditionValue, operator)
      }).length

      return count
    } catch (error) {
      console.warn('cmTableCount 错误:', error)
      return 0
    }
  },

  // 表格求和函数：对表格中符合条件的行的指定字段进行求和
  // tableData: 表格数据（JSON字符串或数组）
  // conditionField: 筛选条件的字段名（可选，如果不提供则对所有行求和）
  // conditionValue: 筛选条件的值（可选，如果不提供则对所有行求和）
  // sumField: 要求和的字段名（必须使用字段的model值）
  // operator: 比较操作符（可选，默认为"=="），支持：==（等于）、!=（不等于）、>（大于）、>=（大于等于）、<（小于）、<=（小于等于）、contains（包含）、not_contains（不包含）、startsWith（以...开头）、endsWith（以...结尾）、is_empty（为空）、is_not_empty（不为空）
  cmTableSum(tableData, conditionField, conditionValue, sumField, operator) {
    try {
      // 解析表格数据
      let parsedData = tableData
      if (typeof tableData === 'string') {
        try {
          parsedData = JSON.parse(tableData)
        } catch (e) {
          // 如果解析失败，尝试再次解析（可能是双重JSON字符串）
          try {
            parsedData = JSON.parse(JSON.parse(tableData))
          } catch (e2) {
            return 0
          }
        }
      }

      if (!Array.isArray(parsedData) || parsedData.length === 0) {
        return 0
      }

      // 如果没有提供条件字段和条件值，则对所有行求和
      let filteredData = parsedData
      if (conditionField !== undefined && conditionField !== null && conditionField !== '') {
        filteredData = parsedData.filter(row => {
          const rowValue = row[conditionField]
          return this._evaluateTableCondition(rowValue, conditionValue, operator)
        })
      }

      // 如果没有符合条件的行，返回0
      if (filteredData.length === 0) {
        return 0
      }

      // 对符合条件的行进行求和
      let sum = 0
      filteredData.forEach(row => {
        const value = row[sumField]
        if (value !== undefined && value !== null && value !== '') {
          const numValue = Number(value)
          if (!isNaN(numValue)) {
            sum += numValue
          }
        }
      })

      return sum
    } catch (error) {
      console.warn('cmTableSum 错误:', error)
      return 0
    }
  },

  // 表格拼接函数：遍历表格每行并拼接指定字段，最后拼接主表字段
  // tableData: 表格数据（JSON字符串或数组）
  // rowSeparator: 行内分隔符，用于分隔同一行的不同字段组，如 "-"
  // fieldList: 要拼接的表格字段model列表，支持字段分组、自定义分隔符和后缀
  //   格式1：简单列表，用逗号分隔，如 "productName,width,height"
  //   格式2：字段分组，用逗号分隔组，组内用*分隔字段，如 "productName,width*height,quantity"
  //   格式3：自定义组内分隔符，用竖线|指定分隔符，如 "width|X|height" 表示用X连接，或 "width| |height" 表示用空格连接
  //   格式4：添加后缀，用冒号:添加后缀，如 "width*height:MM" 表示宽高组后面加MM
  //   示例：如果宽和高要用空格连接，后面加MM，可以写成 "productName,width| |height:MM,quantity"
  // lineSeparator: 行间分隔符，用于分隔不同行，如 "-" 或 ";"
  // mainFields: 可选，要拼接的主表字段model列表，用逗号分隔，如 "customerName,phone"
  // mainFormData: 可选，主表数据对象，用于获取主表字段值
  // showIndex: 可选，是否显示行序号，true/false，默认为false
  // indexFormat: 可选，序号格式，如 "1. " 或 "第1行："，支持 {index} 占位符，默认为 "{index}. "
  cmTableJoin(tableData, rowSeparator, fieldList, lineSeparator, mainFields, mainFormData, showIndex, indexFormat) {
    try {
      // 解析表格数据
      let parsedData = tableData
      if (typeof tableData === 'string') {
        try {
          parsedData = JSON.parse(tableData)
        } catch (e) {
          // 如果解析失败，尝试再次解析（可能是双重JSON字符串）
          try {
            parsedData = JSON.parse(JSON.parse(tableData))
          } catch (e2) {
            return ''
          }
        }
      }

      if (!Array.isArray(parsedData) || parsedData.length === 0) {
        return ''
      }

      // 解析字段列表，支持字段分组、自定义分隔符、前缀和后缀
      // 格式：用逗号分隔不同的字段组，组内用*分隔字段
      // 支持后缀：用冒号:添加后缀，如 "width*height:MM" 表示宽高组后面加MM
      // 支持前缀和后缀：用双冒号::分隔，如 "address:【::】" 表示地址前后加【】
      // 例如："productName,width*height:MM,address:【::】" 表示：
      // - productName 单独一组
      // - width 和 height 用 * 连接成一组，后面加 MM（如：50*40MM）
      // - address 单独一组，前后加【】（如：【地址内容】）
      // 然后用 rowSeparator 连接这些组
      const fieldGroups = fieldList ? fieldList.split(',').map(g => g.trim()).filter(g => g) : []
      if (fieldGroups.length === 0) {
        return ''
      }

      // 遍历表格每一行，拼接字段
      const rowResults = []
      parsedData.forEach((row, index) => {
        const groupValues = []
        
        // 处理每个字段组
        fieldGroups.forEach(group => {
          // 检查是否包含前缀和后缀（冒号:）
          // 格式1：字段名:后缀 - 只添加后缀
          // 格式2：字段名:前缀::后缀 - 添加前缀和后缀（用双冒号::分隔）
          // 格式3：字段名:前缀:: - 只添加前缀
          let prefix = ''
          let suffix = ''
          let groupWithoutPrefixSuffix = group
          if (group.includes(':')) {
            const parts = group.split(':')
            groupWithoutPrefixSuffix = parts[0].trim()
            const suffixPart = parts.slice(1).join(':') // 保留所有冒号
            
            // 检查是否包含双冒号::（前缀和后缀分隔符）
            if (suffixPart.includes('::')) {
              const prefixSuffixParts = suffixPart.split('::')
              prefix = prefixSuffixParts[0] || ''
              suffix = prefixSuffixParts.slice(1).join('::') || '' // 支持后缀中包含双冒号的情况
            } else {
              // 只有后缀，没有前缀
              suffix = suffixPart.trim()
            }
          }
          
          // 检查是否包含自定义分隔符（竖线|），格式：字段1|分隔符|字段2
          // 例如：width|X|height 表示用X连接，width| |height 表示用空格连接
          // 支持 || 作为空分隔符（直接连接），例如：field1||field2 表示直接连接，无分隔符
          // 支持条件判断：field1|分隔符|field2?conditionField 或 field1|分隔符|field2?conditionField:operator
          if (groupWithoutPrefixSuffix.includes('|')) {
            let fieldsStr = groupWithoutPrefixSuffix
            let conditionField = null
            let conditionOperator = 'is_not_empty'
            
            // 检查是否包含条件判断（在|之后）
            if (groupWithoutPrefixSuffix.includes('?')) {
              const parts = groupWithoutPrefixSuffix.split('?')
              fieldsStr = parts[0].trim()
              const conditionPart = parts[1] || ''
              
              if (conditionPart.includes(':')) {
                const conditionParts = conditionPart.split(':')
                conditionField = conditionParts[0].trim()
                conditionOperator = conditionParts[1]?.trim() || 'is_not_empty'
              } else {
                conditionField = conditionPart.trim()
              }
            }
            
            // 先检查是否是 || 格式（空分隔符，直接连接）
            // 格式：field1||field2 或 field1||field2?conditionField
            if (fieldsStr.includes('||')) {
              const doublePipeParts = fieldsStr.split('||')
              if (doublePipeParts.length === 2) {
                const field1 = doublePipeParts[0].trim()
                const field2 = doublePipeParts[1].trim()
                
                // 如果有条件字段，先检查条件
                if (conditionField) {
                  const conditionValue = row[conditionField]
                  const conditionMet = this._evaluateTableCondition(conditionValue, '', conditionOperator)
                  
                  // 如果条件不满足，跳过该字段组
                  if (!conditionMet) {
                    return // 跳过这个字段组
                  }
                }
                
                const value1 = row[field1]
                const value2 = row[field2]
                const fieldValues = []
                
                if (value1 !== undefined && value1 !== null && value1 !== '') {
                  fieldValues.push(String(value1))
                }
                if (value2 !== undefined && value2 !== null && value2 !== '') {
                  fieldValues.push(String(value2))
                }
                
                // 如果组内有值，直接连接（无分隔符），然后添加前缀和后缀
                if (fieldValues.length > 0) {
                  let groupValue = fieldValues.join('') // 空字符串连接，直接拼接
                  if (prefix) {
                    groupValue = prefix + groupValue
                  }
                  if (suffix) {
                    groupValue += suffix
                  }
                  groupValues.push(groupValue)
                }
                
                return // 处理完成，跳出当前字段组的处理
              }
            }
            
            const parts = fieldsStr.split('|')
            if (parts.length === 3) {
              // 如果有条件字段，先检查条件
              if (conditionField) {
                const conditionValue = row[conditionField]
                const conditionMet = this._evaluateTableCondition(conditionValue, '', conditionOperator)
                
                // 如果条件不满足，跳过该字段组
                if (!conditionMet) {
                  return // 跳过这个字段组
                }
              }
              
              // 自定义分隔符格式：字段1|分隔符|字段2
              const field1 = parts[0].trim()
              const customSeparator = parts[1] // 保留原始分隔符（可能是空格）
              const field2 = parts[2].trim()
              
              const value1 = row[field1]
              const value2 = row[field2]
              const fieldValues = []
              
              if (value1 !== undefined && value1 !== null && value1 !== '') {
                fieldValues.push(String(value1))
              }
              if (value2 !== undefined && value2 !== null && value2 !== '') {
                fieldValues.push(String(value2))
              }
              
              // 如果组内有值，用自定义分隔符连接，然后添加前缀和后缀
              if (fieldValues.length > 0) {
                let groupValue = fieldValues.join(customSeparator)
                if (prefix) {
                  groupValue = prefix + groupValue
                }
                if (suffix) {
                  groupValue += suffix
                }
                groupValues.push(groupValue)
              }
            } else {
              // 格式错误，按单个字段处理（但也要支持条件判断）
              let actualField = fieldsStr
              if (conditionField) {
                const conditionValue = row[conditionField]
                const conditionMet = this._evaluateTableCondition(conditionValue, '', conditionOperator)
                if (!conditionMet) {
                  return // 跳过这个字段组
                }
              }
              
              const value = row[actualField]
              if (value !== undefined && value !== null && value !== '') {
                let fieldValue = String(value)
                if (prefix) {
                  fieldValue = prefix + fieldValue
                }
                if (suffix) {
                  fieldValue += suffix
                }
                groupValues.push(fieldValue)
              }
            }
          } else if (groupWithoutPrefixSuffix.includes('*')) {
            // 字段组：用 * 分隔的多个字段（默认方式）
            // 支持条件判断：field1*field2?conditionField 或 field1*field2?conditionField:operator
            let fieldsStr = groupWithoutPrefixSuffix
            let conditionField = null
            let conditionOperator = 'is_not_empty'
            
            // 检查是否包含条件判断
            if (groupWithoutPrefixSuffix.includes('?')) {
              const parts = groupWithoutPrefixSuffix.split('?')
              fieldsStr = parts[0].trim()
              const conditionPart = parts[1] || ''
              
              if (conditionPart.includes(':')) {
                const conditionParts = conditionPart.split(':')
                conditionField = conditionParts[0].trim()
                conditionOperator = conditionParts[1]?.trim() || 'is_not_empty'
              } else {
                conditionField = conditionPart.trim()
              }
            }
            
            // 如果有条件字段，先检查条件
            if (conditionField) {
              const conditionValue = row[conditionField]
              const conditionMet = this._evaluateTableCondition(conditionValue, '', conditionOperator)
              
              // 如果条件不满足，跳过该字段组
              if (!conditionMet) {
                return // 跳过这个字段组
              }
            }
            
            const fields = fieldsStr.split('*').map(f => f.trim()).filter(f => f)
            const fieldValues = []
            fields.forEach(field => {
              const value = row[field]
              // 只添加非空值
              if (value !== undefined && value !== null && value !== '') {
                fieldValues.push(String(value))
              }
            })
            // 如果组内有值，用 * 连接，然后添加前缀和后缀
            if (fieldValues.length > 0) {
              let groupValue = fieldValues.join('*')
              if (prefix) {
                groupValue = prefix + groupValue
              }
              if (suffix) {
                groupValue += suffix
              }
              groupValues.push(groupValue)
            }
          } else {
            // 单个字段
            // 检查是否包含条件判断（使用?符号）
            // 格式：field?conditionField 或 field?conditionField:operator
            // 例如：field1?field2 表示只有当 field2 不为空时，才拼接 field1
            // 例如：field1?field2:is_not_empty 表示只有当 field2 不为空时，才拼接 field1
            let actualField = groupWithoutPrefixSuffix
            let conditionField = null
            let conditionOperator = 'is_not_empty' // 默认条件：不为空
            
            if (groupWithoutPrefixSuffix.includes('?')) {
              const parts = groupWithoutPrefixSuffix.split('?')
              actualField = parts[0].trim()
              const conditionPart = parts[1] || ''
              
              if (conditionPart.includes(':')) {
                // 格式：field?conditionField:operator
                const conditionParts = conditionPart.split(':')
                conditionField = conditionParts[0].trim()
                conditionOperator = conditionParts[1]?.trim() || 'is_not_empty'
              } else {
                // 格式：field?conditionField（默认使用 is_not_empty）
                conditionField = conditionPart.trim()
              }
            }
            
            // 如果有条件字段，先检查条件
            if (conditionField) {
              const conditionValue = row[conditionField]
              const conditionMet = this._evaluateTableCondition(conditionValue, '', conditionOperator)
              
              // 如果条件不满足，跳过该字段
              if (!conditionMet) {
                return // 跳过这个字段组
              }
            }
            
            // 获取字段值并拼接
            const value = row[actualField]
            if (value !== undefined && value !== null && value !== '') {
              let fieldValue = String(value)
              // 如果有前缀，添加前缀
              if (prefix) {
                fieldValue = prefix + fieldValue
              }
              // 如果有后缀，添加后缀
              if (suffix) {
                fieldValue += suffix
              }
              groupValues.push(fieldValue)
            }
          }
        })
        
        // 如果该行有值，用行内分隔符连接所有组，添加到结果中
        if (groupValues.length > 0) {
          let rowContent = groupValues.join(rowSeparator || '-')
          
          // 如果需要显示序号
          if (showIndex === true || showIndex === 'true' || showIndex === 1 || showIndex === '1') {
            const rowIndex = index + 1 // 序号从1开始
            let format = indexFormat || '{index}. '
            // 替换占位符
            format = format.replace(/{index}/g, rowIndex)
            rowContent = format + rowContent
          }
          
          rowResults.push(rowContent)
        }
      })

      // 拼接所有行
      let result = rowResults.join(lineSeparator || '-')

      // 如果指定了主表字段，拼接主表字段
      if (mainFields && mainFormData) {
        const mainFieldList = mainFields.split(',').map(f => f.trim()).filter(f => f)
        if (mainFieldList.length > 0) {
          const mainValues = []
          mainFieldList.forEach(field => {
            const value = mainFormData[field]
            if (value !== undefined && value !== null && value !== '') {
              mainValues.push(String(value))
            }
          })
          if (mainValues.length > 0) {
            // 如果表格有数据，先添加分隔符再拼接主表字段
            if (result) {
              result += (lineSeparator || '-') + mainValues.join(rowSeparator || '-')
            } else {
              result = mainValues.join(rowSeparator || '-')
            }
          }
        }
      }

      return result
    } catch (error) {
      console.warn('cmTableJoin 错误:', error)
      return ''
    }
  },

  // 获取当前行号函数（在表格字段公式中使用）
  // 注意：此函数在公式计算时会被特殊处理，直接替换为实际行号值
  // 行号从1开始计数
  cmRowIndex() {
    // 此函数在公式计算时会被特殊处理，不会真正执行到这里
    // 如果执行到这里，说明没有在表格字段中使用，返回0
    console.warn('ROWINDEX() 函数只能在表格字段的公式中使用')
    return 0
  }

}
